/* eslint-disable no-unused-vars */

import flatpickr from 'flatpickr';
import autosize from 'autosize';
import select2 from 'select2';
import tooltipster from 'tooltipster';

var custom = (function ($, window, document, Drupal, flatpickr, autosize) {
  Drupal.behaviors.specialEvaluationModal = {
    attach: function (context, settings) {
      $('#edit-special-evaluation-link').on('click', function(){
        //fixes rangeslider width on modal
        setTimeout(function () { window.dispatchEvent(new Event('resize'));}, 500);
      });
    },
  };

  Drupal.behaviors.flatpickrSetup = {
    attach: function (context, settings) {

      const getTranslatedLocale = () => ({
        firstDayOfWeek: 1,
        weekdays: {
          shorthand: settings.datesLocale.weekdays.shorthand.map(String),
          longhand: settings.datesLocale.weekdays.longhand.map(String),
        },
        months: {
          shorthand: settings.datesLocale.months.shorthand.map(String),
          longhand: settings.datesLocale.months.longhand.map(String),
        }
      });

      const initFlatpickr = (selector, options = {}) => {
        $(once('flatpickr-init', selector, context)).each(function () {
          if (this._flatpickr) {
            this._flatpickr.destroy();
          }
          $(this).flatpickr({
            locale: getTranslatedLocale(),
            ...options
          });
        });
      };

      $("input.flowit-flatpickr-date-details.form-text").flatpickr({
        minDate: "today",
        position: "auto left",
        dateFormat: "d.m.Y",
        locale: getTranslatedLocale()
      });

      $("input.flowit-flatpickr-date.form-text").flatpickr({
        minDate: "today",
        position: "auto right",
        dateFormat: "d.m.Y",
        locale: getTranslatedLocale()
      });

      $("input.flowit-flatpickr-time.form-text").flatpickr({
        enableTime: true,
        noCalendar: true,
        time_24hr: true,
        position: "auto right",
        dateFormat: "H:i",
      });

      $("input.flowit-flatpickr-notification-time.form-text").flatpickr({
        enableTime: true,
        noCalendar: true,
        time_24hr: true,
        position: "auto right",
        dateFormat: "H:i",
        minTime: "08:00",
        maxTime: "17:00",
        minuteIncrement: 30,
      });

      $("input.flowit-flatpickr-date-okr").flatpickr({
        position: "auto right",
        dateFormat: "d.m.Y",
        locale: getTranslatedLocale()
      });

      $("input.flowit-flatpickr-date-birthday-ymd").flatpickr({
        maxDate: "today",
        position: "auto right",
        dateFormat: "Y-m-d",
        locale: getTranslatedLocale()
      });

      $("input.flowit-flatpickr-date-birthday").flatpickr({
        maxDate: "today",
        position: "auto right",
        dateFormat: "d.m.Y",
        locale: getTranslatedLocale()
      });

      $("input.flowit-flatpickr-date-role").flatpickr({
        position: "auto right",
        dateFormat: "Y-m-d",
        locale: getTranslatedLocale()
      });

      $("input.flowit-flatpickr-date-create-review").attr("placeholder", "DD.MM.YYYY").flatpickr({
        position: "auto right",
        altInput: true,
        dateFormat: "Y-m-d",
        altFormat: "d.m.Y",
        locale: getTranslatedLocale()
      });
    },
  };

  // open / close context menu
  Drupal.behaviors.contextMenu = {
    attach: function(context, settings) {
      const elements = once('clickDropMenu', '.drop', context);

      elements.forEach((element) => {
        const $this = $(element);

        $this.on('click', function () {
          const other_clicked = $('.drop').hasClass('drop--clicked');
          const element_clicked = $(this).hasClass('drop--clicked');

          $('.drop').removeClass('drop--clicked');
          $('.contextual-menu').removeClass('contextual-menu--visible');

          $(this).toggleClass('drop--clicked');
          $(this).closest('.context-menu').find('.contextual-menu').toggleClass('contextual-menu--visible');

          if (other_clicked && element_clicked) {
            $(this).removeClass('drop--clicked');
            $(this).closest('.context-menu').find('.contextual-menu').removeClass('contextual-menu--visible');
          }
        });
      });

      // close context menu when clicking outside
      const body = once('clickOutside', 'body', context);
      $(body).on('click', function(e){
        if(!$(e.target).hasClass('contextual-menu') && !$(e.target).hasClass('drop')){
          $('.drop').removeClass('drop--clicked');
          $('.contextual-menu').removeClass('contextual-menu--visible');
        }
      });
    }
  }

  Drupal.behaviors.autosize = {
    attach: function(context, settings) {
      autosize($('.autosize'));
    }
  }

  Drupal.behaviors.rangeSliderEvaluation = {
    attach: function(context, settings) {

      const isEvaluationsPage = $('.path-assessments').length;
      const isFeedbackRespondCreatePage = $('body[class*="path-instant-feedback-respond-create"]').length;
      const isFeedbackCreatePage = $('body[class*="path-instant-feedback-create"]').length;
      const isSurveyEditPage = $('body[class*="path-surveys-edit"]').length;
      const isReviewEditPage = $('body[class*="path-reviews-edit"]').length;

      function slider () {
        const $sliderContainer = $('.js-form-type-range-slider');
        const $submitButton = $('input[id*="edit-submit"]');

        $sliderContainer.each((i, el) => {
          const $sliderValue = $(el).find('input[type="range"]');

          // validation
          if ($sliderValue.attr('value') == 0 || $sliderValue.attr('value') == '0' || $sliderValue.attr('value') == '') {
            // remove indicator if value = 0
            // $sliderValue.next().next().find('.rangeslider__handle').css('display', 'none');
            // $sliderValue.next().next().find('.rangeslider__fill').css('display', 'none');

            if (!isSurveyEditPage && !isFeedbackCreatePage && !isReviewEditPage) {
              $submitButton.css('pointer-events', 'none');
              $sliderValue.attr('is-valid', false);
            }
          } else {
            if (!isSurveyEditPage && !isFeedbackCreatePage && !isReviewEditPage) {
              const value = $sliderValue.attr('value');
              $sliderValue.next().next().find(`.rangeslider__strokes__stroke:nth-child(-n+${value})`).addClass('active');

              $submitButton.css('pointer-events', 'initial');
              $sliderValue.attr('is-valid', true);
            }
          }
        })

        const $rangeSliders = $('.rangeslider');
        $rangeSliders.each((i, el) => {
          const $dots = $(el).find('.rangeslider__strokes__stroke');

          $dots.each((i, el) => {
            const $dot = $(el);

            // if ($dot.next().length) {
            //   var marginBetween = $dot.next().offset().left - $dot.offset().left - $dot.outerHeight();
            // }

            // add element between dots
            // const $hideFill = $('<div class="rangeslider__strokes__hide-fill"></div>');
            // $hideFill.css({
            //   'width': marginBetween,
            //   'left': i * marginBetween + ((i + 1) * $dot.outerHeight())
            // });
            // if (!$dot.prev().hasClass('rangeslider__strokes__hide-fill')) {
            //   $hideFill.insertBefore($dot);
            // }

            if (!isSurveyEditPage && !isFeedbackCreatePage && !isReviewEditPage) {
              // validation on load
              const isValid = $('input[is-valid="false"]').length;
              if (isValid != 0) {
                $submitButton.css('pointer-events', 'none');
              } else {
                $submitButton.css('pointer-events', 'initial');
              }
              // on click
              $dot.on('click', () => {
                // add indicator
                // $dot.parent().prev().css('display', 'block');
                // $dot.parent().prev().prev().css('display', 'block');

                // validation
                $dot.parent().parent().prev().prev().attr('is-valid', true);
                const isValid = $('input[is-valid="false"]').length;
                if (isValid != 0) {
                  $submitButton.css('pointer-events', 'none');
                } else {
                  $submitButton.css('pointer-events', 'initial');
                }
              });
            }
          });
        });
      }

      function applySliderVisualsPerSlider() {
        $('.evaluation-screen-form input[type=range]').each((i, el) => {
          const $range = $(el);
          const isValid = $range.attr('is-valid') === 'true';
          const value = parseInt($range.val(), 10);

          if (!isValid || isNaN(value) || value <= 0) return;

          setTimeout(() => {
            const $strokes = $range.next().next().find('.rangeslider__strokes__stroke');
            if ($strokes.length) {
              $strokes.removeClass('active');
              $strokes.slice(0, value).addClass('active');
            }
          }, 100);
        });
      }

      if (isEvaluationsPage || isFeedbackRespondCreatePage || isFeedbackCreatePage || isSurveyEditPage || isReviewEditPage) {
        slider();

        if (isFeedbackRespondCreatePage || isFeedbackCreatePage) {
          const elements = once('feedbackRangeSlider', '.rangeslider', context);
          elements.forEach((element) => {
            const $this = $(element);

            const $dotFirst = $this.find('.rangeslider__strokes__stroke:first-of-type');

            if ($dotFirst.next().length) {
              const marginBetween = $dotFirst.next().offset().left - $dotFirst.offset().left - $dotFirst.outerWidth();

              const newLeft = $this.offset().left - ($dotFirst.outerWidth() + marginBetween) / 2;

              const padding = $this.offset().left - newLeft;

              $this.offset({left: newLeft});

              const $label = $this.parent().find('> .form-element-label');

              $label.css({
                'padding-left': padding,
                'padding-right': padding
              });
            }
          });
        }

        // if (isEvaluationsPage) {
        //   $('.special-evaluation-screen-form').css('opacity', '0')

        //   $.ajax().done(() => {
        //     $('.special-evaluation-screen-form').css('opacity', '1')
        //     slider();
        //   });
        // }

        if (isFeedbackCreatePage) {
          $('input[type=range]').each((i, el) => {
            const value = $(el).attr('value');
            $(el).next().next().find(`.rangeslider__strokes__stroke:nth-child(-n+${Number(value) + 1})`).addClass('active');
          });
        }

        if (isEvaluationsPage) {
          $(document).ready(() => {
            setTimeout(() => {
              applySliderVisualsPerSlider();
            }, 100);
          });
        }
      }
    }
  }

  Drupal.behaviors.goBackButton = {
    attach: function(context, settings) {
      const $backButton = $('.back-link');
      const $teamTabs = $('#edit-team-tabs');
      const $teamTab = $teamTabs.find('.tabs__tab');
      const $teamStatistics = $('#teams-details-statistics-insights-form');
      const $messageInfo = $('div[role="contentinfo"]');
      const $scrollMenu = $('.scroll-menu');
      const $scrollMenuTab = $scrollMenu.find('a');

      // /insights/teams/10/statistics/6m
      let counter = sessionStorage.getItem('counter') || 1;

      // /activity-board/all
      let counter2 = sessionStorage.getItem('counter2') || 1;

      $teamTab.on('click', () => {
        counter++;
        sessionStorage.setItem('counter', counter);
      });

      if ($backButton.length) {
        $scrollMenuTab.on('click', () => {
          counter2++;
          sessionStorage.setItem('counter2', counter2);
        });
      }

      if (window.location.pathname.includes('instant-feedback/details')) {
        const path = '/instant-feedback';
        const url = new URL(path, window.location.origin);

        const params = new URLSearchParams(window.location.search);
        const feedbackParam = params.get('feedbacks');
        const requestsParam = params.get('requests');

        if (requestsParam) {
          url.searchParams.set('requests', requestsParam);
        }
        else if (feedbackParam) {
          url.searchParams.set('feedbacks', feedbackParam);
        }
        else {
          url.searchParams.set('feedbacks', 'received');
        }

        const pageParam = params.get('page');
        if (pageParam) {
          url.searchParams.set('page', pageParam);
        }

        $backButton.attr('href', url.toString());
      }

      if ($backButton.attr('href') && $backButton.attr('href').includes('confirm') && window.location.pathname.includes('app/teams')) {
        //$backButton.attr('href', `javascript:history.go(-4)`);
        $backButton.attr('href', `/app/teams`);
      } else if ($messageInfo.length) {
        if (window.location.pathname.includes('cards/')) {
          $backButton.attr('href', 'javascript:history.go(-2)');
        }
        if (window.location.pathname.includes('app/teams/')) {
          $backButton.attr('href', `/app/teams`);
        }
        if (window.location.pathname.includes('user') && window.location.pathname.includes('edit')) {
          $backButton.attr('href', `/profile`);
        }
      } else if ((window.location.pathname.includes('/app/card-manager/card/') && window.location.pathname.includes('/edit')) || window.location.pathname.includes('/app/card-manager/card/create')) {
        $backButton.attr('href', `/app/card-manager`);
      } else if (window.location.pathname.includes('app/teams') && window.location.pathname.split('/').length == 4) {
        $backButton.attr('href', `/app/teams`);
      } else if (window.location.pathname.includes('/app/employees/') && window.location.href.includes('edit?uid=')) {
        $backButton.attr('href', 'javascript:history.go(-1)');
      } else if (window.location.pathname.includes('/app/employees/') && window.location.pathname.includes('edit')) {
        $backButton.attr('href', `/app/employees`);
      } else if (window.location.pathname.includes('profile/teams/')) {
        $backButton.attr('href', `/profile`);
      } else if (window.location.pathname.endsWith('profile')) {
        if ($backButton.data('referrer-path') && ($backButton.data('referrer-path').includes('/surveys/insights') || $backButton.data('referrer-path').includes('/insights/surveys'))) {
          $backButton.attr('href', 'javascript:history.go(-1)');
        } else {
          $backButton.attr('href', `/home`);
        }
      } else if (window.location.pathname.includes('user') && window.location.pathname.includes('edit')) {
        $backButton.attr('href', `/profile`);
      } else if (window.location.pathname.includes('profile') && window.location.pathname.includes('skills') && window.location.pathname.includes('add')) {
        $backButton.attr('href', `/profile`);
      } else if (window.location.pathname.includes('profile') && window.location.pathname.includes('/role-comparison')) {
        $backButton.attr('href', `/profile`);
      } else if (window.location.pathname.includes('/profile/') && window.location.pathname.includes('/cards/')) {
        const id = window.location.pathname.split('/profile/')[1].split('/')[0];

        setTimeout(() => {
          $('.back-link').attr('href', `/profile/${id}/cards`);
        }, 1000)
      } else if (window.location.pathname.includes('/profile/') && window.location.pathname.includes('/cards/add/')) {
        const id = window.location.pathname.split('/profile/')[1].split('/')[0];

        $backButton.attr('href', `/profile/${id}/cards`);
      } else if (window.location.pathname.includes('/profile/')) {
        const id = window.location.pathname.split('/profile/')[1];

        if (!isNaN(id) && window.location.pathname === '/profile/' + id) {
          if ($('body').data('user-id') == Number(id)) {
            $backButton.attr('href', `/home`);
          } else {
            if ($backButton.data('referrer-path') && $backButton.data('referrer-path').includes('/profile/teams')) {
              $backButton.attr('href', $backButton.data('referrer-path'));
            } else if ($backButton.data('referrer-path') && $backButton.data('referrer-path').includes('profile/teams')) {
              const id = $backButton.data('referrer-path').split('teams/')[1]
              $backButton.attr('href', `/profile/teams/${id}`);
            } else if ($backButton.data('referrer-path') && $backButton.data('referrer-path').includes('/notes')) {
              $backButton.attr('href', 'javascript:history.go(-1)');
            } else if ($backButton.data('referrer-path') && ($backButton.data('referrer-path').includes('/surveys/insights') || $backButton.data('referrer-path').includes('/insights/surveys'))) {
              $backButton.attr('href', 'javascript:history.go(-1)');
            } else {
              $backButton.attr('href', `/home`);
            }
          }
        }
      } else if (window.location.href == $backButton.attr('href') && !window.location.pathname.includes('home/history') && !window.location.pathname.includes('meetings/details') && !window.location.pathname.includes('/cards')) {
        $backButton.attr('href', 'javascript:history.go(-2)');
      } else if (window.location.href == $backButton.attr('href') && window.location.pathname.includes('dashboard/history')) {
        $backButton.attr('href', `/profile`);
      } else if (window.location.href == $backButton.attr('href') && window.location.pathname.includes('meetings/details')) {
        $backButton.attr('href', `/meetings`);
      } else if (window.location.pathname.includes('/assessments') && window.location.pathname.includes('/evaluation')) {
        $backButton.attr('href', `/assessments`);
      } else if (window.location.pathname.includes('/assessments/past')) {
        $backButton.attr('href', `/assessments`);
      } else if (window.location.pathname.includes('/dashboard/history/evaluation/') && window.location.pathname.includes('/details')) {
        // Came from email.
        const isCameFromEmail = $backButton.attr('href') && (!$backButton.attr('href').includes('/home/history/') && !$backButton.attr('href').includes('/insights/evaluations'));
        if (isCameFromEmail) {
          $backButton.attr('href', `/assessments/past`);
        }
      /*} else if (window.location.pathname.includes('/instant-feedback/details/')) {
        $backButton.attr('href', `/instant-feedback`);*/
      } else if (window.location.pathname.includes('/app/employees/create')) {
        $backButton.attr('href', `/app/employees`);
      } else if (window.location.pathname == $backButton.attr('href') && !window.location.pathname.includes('user') && !window.location.pathname.includes('edit') &&
      !window.location.pathname.includes('/insights/reviews') && !window.location.pathname.includes('/reviews/insights') &&
      !window.location.pathname.includes('/insights/surveys') && !window.location.pathname.includes('/surveys/insights')
    ) {
        $backButton.attr('href', 'javascript:history.go(-2)');
      } else if (window.location.pathname.includes('dashboard/history') && $backButton.attr('href') && $backButton.attr('href').includes('details')) {
        $backButton.attr('href', `/profile`);
      } else if ($backButton.attr('href') && $backButton.attr('href').includes('/meetings/create')) {
        $backButton.attr('href', `/profile`);
      } else if (window.location.href.includes('/profile/') && $backButton.attr('href') && $backButton.attr('href').includes('meetings/details')) {
        $backButton.attr('href', `/home`);
      } else if (window.location.href.includes('/meetings/details') && $backButton.attr('href') && $backButton.attr('href').includes('?')) {
        $backButton.attr('href', 'javascript:history.go(-2)');
      } else if (window.location.href.includes('/meetings/details') && $backButton.attr('href') && $backButton.attr('href').includes('meetings/edit')) {
        $backButton.attr('href', `/meetings`);
      } else if (window.location.pathname.includes('meetings/details') && $backButton.attr('href') && $backButton.attr('href').includes('confirmation')) {
        $backButton.attr('href', `/meetings`);
      } else if (window.location.pathname.includes('app/role') && window.location.pathname.includes('edit')) {
        $backButton.attr('href', `/app/skill-role-manager`);
      }

      if (window.location.pathname.includes('/profile/') && window.location.pathname.includes('/notes')) {
        const id = window.location.pathname.split('/profile/')[1].split('/')[0];

        if (window.location.pathname.includes('/notes/')) {
          $backButton.attr('href', `/profile/${id}/notes`);
        } else {
          $backButton.attr('href', `/profile/${id}`);
        }
      }

      if (window.location.pathname.includes('/reviews')) {
        if (window.location.pathname.includes('/my-reviews/active') || window.location.pathname.includes('/templates')) {
          $backButton.attr('href', `/reviews`);
        }

        if (window.location.pathname.includes('/my-reviews/')) {
          if (window.location.pathname.includes('/completed') || window.location.pathname.includes('/draft') || window.location.pathname.includes('/scheduled')) {
            $backButton.attr('href', `/reviews/my-reviews/active`);
          }
        }

        if (window.location.pathname.includes('/reviews/create/')) {
          $backButton.attr('href', $backButton.data('referrer-path'));
        }

        if (window.location.pathname.includes('/reviews/create/template/')) {
          $backButton.attr('href', `/reviews/new/reviews-edit`);
        }

        if (window.location.pathname.includes('/reviews/new/reviews-edit')) {
          $backButton.attr('href', `/reviews/templates`);
        }

        if (window.location.pathname.includes('/reviews/edit/') && !window.location.pathname.includes('/add/') && !window.location.pathname.includes('/section/edit/')) {
          $backButton.attr('href', `/reviews/templates`);
        }

        if (window.location.pathname.includes('/edit/active/review/') || (window.location.pathname.includes('/edit/completed/review/'))) {
          if ($backButton.data('referrer-path') && $backButton.data('referrer-path').includes('/reviews/my-reviews')) {
            $backButton.attr('href', $backButton.data('referrer-path'));
          } else {
            $backButton.attr('href', 'javascript:history.go(-1)');
          }
        }

        if (window.location.pathname.includes('/reviews/edit/template/')) {
          $backButton.attr('href', `/reviews/edit/template`);
        }

        if (window.location.pathname.includes('/reviews/display/')) {
          if (window.location.pathname.includes('/overview') || window.location.pathname.includes('/details') || window.location.pathname.includes('/conclusion-resolution')) {
            if ($backButton.data('referrer-path') && $backButton.data('referrer-path').includes('/reviews/my-reviews')) {
              $backButton.attr('href', $backButton.data('referrer-path'));
            } else if ($backButton.data('referrer-path') && $backButton.data('referrer-path').includes('/reviews/display/') && $backButton.data('referrer-path').includes('/details')) {
              $backButton.attr('href', $backButton.data('referrer-path'));
            } else if ($backButton.data('referrer-path') && $backButton.data('referrer-path').includes('/reviews/display/')) {
              $backButton.attr('href', `/reviews/my-reviews/completed`);
            } else {
              $backButton.attr('href', 'javascript:history.go(-1)');
            }
          }
        }

        if (window.location.pathname.includes('/insights')) {
          if (window.location.search.length) {
            let hrefArr = JSON.parse(localStorage.getItem('hrefArr'));
            if (!hrefArr) {
              hrefArr = [];
            }

            if (hrefArr[hrefArr.length - 1] !== window.location.href) {
              hrefArr.push(window.location.href);
            }

            window.localStorage.setItem('hrefArr', JSON.stringify(hrefArr));

            $backButton.attr('href', hrefArr[hrefArr.length - 2]);

            $backButton.on('click', () => {
              hrefArr.pop();
              window.localStorage.setItem('hrefArr', JSON.stringify(hrefArr));
            });
          } else {
            $backButton.attr('href', '/home');
            localStorage.removeItem('hrefArr');
          }
        }
      }

      if (window.location.pathname.includes('/surveys')) {
        if ($backButton.attr('href') && $backButton.attr('href').includes('/section/add')) {
          $backButton.attr('href', '/surveys/my-surveys/active');
        } else if ($backButton.attr('href') && $backButton.attr('href').includes('/remove/')) {
          $backButton.attr('href', '/surveys/my-surveys/active');
        } else if ($backButton.attr('href') && $backButton.attr('href').includes('create-success')) {
          $backButton.attr('href', `/surveys`);
        } else if ($backButton.attr('href') && $backButton.attr('href').includes('surveys/create')) {
          $backButton.attr('href', `/surveys`);
        } else if (window.location.href.includes('/surveys/edit/') && window.location.href.includes('/section/add')) {
          $backButton.attr('href', 'javascript:history.go(-1)');
        } else if (window.location.href.includes('/surveys/edit/') && window.location.href.includes('/add/')) {
          $backButton.attr('href', 'javascript:history.go(-1)');
        } else if (window.location.href.includes('/surveys/edit/settings/')) {
          $backButton.attr('href', 'javascript:history.go(-1)');
        } else if ($backButton.attr('href') && $backButton.attr('href').includes('surveys/edit') && window.location.href.includes('/element/')) {
          $backButton.attr('href', 'javascript:history.go(-1)');
        } else if (window.location.href.includes('/surveys/create/')) {
          sessionStorage.setItem('survey-create', window.location.pathname);
          $backButton.attr('href', `/surveys/new`);
        } else if (!window.location.href.includes('/surveys')) {
          sessionStorage.removeItem('survey-create');
        } else if (window.location.href.includes('surveys/edit')) {
          $backButton.attr('href', 'javascript:history.go(-1)');
        } else if (window.location.href.includes('/surveys/results/')) {
          if ($backButton.data('referrer-path') && $backButton.data('referrer-path').includes('/insights')) {
            $backButton.attr('href', 'javascript:history.go(-1)');
          } else {
            $backButton.attr('href', '/surveys/my-surveys/completed');
          }
        } else if (window.location.href.includes('/surveys/my-surveys')) {
          $backButton.attr('href', `/surveys`);
        }
      }

      $backButton.on('click', () => {
        sessionStorage.setItem('counter', 1);
        sessionStorage.setItem('counter2', 1);
      });

      if (!$teamStatistics.length && !window.location.pathname.includes('members')) {
        sessionStorage.setItem('counter', 1);
      }
      if ($teamStatistics.length && !$scrollMenu.length) {
        $backButton.attr('href', `javascript:history.go(-${counter})`);
      }

      if (!$scrollMenu.length) {
        sessionStorage.setItem('counter2', 1);
      }
      if ($scrollMenu.length && !$teamStatistics.length && !window.location.pathname.includes('profile') && !window.location.pathname.includes('app/settings') && !window.location.pathname.includes('/surveys') && !window.location.pathname.includes('/reviews') && !window.location.pathname.includes('/assessments')) {
        $backButton.attr('href', `javascript:history.go(-${counter2})`);
      }

      if (($teamStatistics.length || window.location.pathname.includes('members')) && $scrollMenu.length) {
        if (counter2 > 1 && counter > 1) {
          $backButton.attr('href', `javascript:history.go(-${Number(counter) + Number(counter2) - 1})`);
        } else {
          if (counter > counter2) {
            $backButton.attr('href', `javascript:history.go(-${counter})`);
          }
          if (counter2 > counter) {
            $backButton.attr('href', `javascript:history.go(-${counter2})`);
          }
        }
      }

      if (!$teamStatistics.length && !$scrollMenu.length && window.location.pathname.includes('insights') && !window.location.pathname.includes('/insights/reviews')) {
        $backButton.attr('href', 'javascript:history.go(-1)');
      }

      if (window.location.pathname.includes('app/settings')) {
        $backButton.attr('href', `/app/settings/general`);
      }

     /**
     * OKR
     */
      if ((window.location.pathname.includes('objective') && window.location.pathname.endsWith('edit')) || (window.location.pathname.includes('okr-archive'))) {
        const referrerPath = $backButton.data('referrer-path');
        let search = '';
        if (referrerPath && referrerPath.includes('?')) {
          search = referrerPath.split('?')[1]
        }
        if (search) {
          $backButton.attr('href', `/okr?${search}`);
        } else {
          $backButton.attr('href', `/okr`);
        }
      } else if (window.location.pathname.includes('objective/') && window.location.pathname.endsWith('key-result/add')) {
        const id = window.location.pathname.split('objective/')[1].split('/')[0];
        $backButton.attr('href', `/objective/${id}/edit`);
      } else if (window.location.pathname.includes('objective/') && window.location.pathname.includes('/key-result') && window.location.pathname.endsWith('/update')) {
        const id = window.location.pathname.split('objective/')[1].split('/')[0];
        $backButton.attr('href', `/objective/${id}/edit`);
      } else if (window.location.pathname.includes('app/period/add')) {
        $backButton.attr('href', `/app/settings/okr`);
      }

      /**
       * Reviews Insights
       */

      if (window.location.pathname.includes('/insights/multi-review-analysis') && (window.location.pathname.includes('/overview') || window.location.pathname.includes('/pain-points') || window.location.pathname.includes('/management_summary'))) {
        $backButton.attr('href', `/insights/multi-review-analysis`);
      } else if (window.location.pathname.includes('/insights/multi-review-analysis')) {
        $backButton.attr('href', `/insights/reviews`);
      }

      // reviews/surveys
      if (window.location.pathname.includes('/insights') && (window.location.pathname.includes('/reviews') || (window.location.pathname.includes('/surveys')))) {
        if (window.location.search.length) {
          let hrefArr = JSON.parse(localStorage.getItem('hrefArr'));
          if (!hrefArr) {
            hrefArr = [];
          }

          if (hrefArr[hrefArr.length - 1] !== window.location.href) {
            hrefArr.push(window.location.href);
          }

          window.localStorage.setItem('hrefArr', JSON.stringify(hrefArr));

          $backButton.attr('href', hrefArr[hrefArr.length - 2]);

          $backButton.on('click', () => {
            hrefArr.pop();
            window.localStorage.setItem('hrefArr', JSON.stringify(hrefArr));
          });
        } else {
          if (window.location.pathname.includes('/insights/reviews') || window.location.pathname.endsWith('/insights/surveys')) {
            $backButton.hide();
          } else {
            if (window.location.pathname.includes('/reviews')) {
              $backButton.attr('href', `/reviews`);
            }

            if (window.location.pathname.includes('/surveys')) {
              if (window.location.pathname.includes('/dashboard')) {
                $backButton.attr('href', `/insights/surveys`);
              }

              if (window.location.pathname.includes('/surveys/insights')) {
                $backButton.attr('href', `/surveys`);
              }
            }
          }

          localStorage.removeItem('hrefArr');
        }
      }

      /**
       * Insights Teams
       */

      if (window.location.pathname.includes('/insights/teams/')) {
        if ($backButton.data('referrer-path') && ($backButton.data('referrer-path').includes('/surveys/insights') || $backButton.data('referrer-path').includes('/insights/surveys'))) {
          $backButton.attr('href', 'javascript:history.go(-1)');
        } else {
          $backButton.attr('href', `/insights/teams`);
        }
      }

      if (window.location.pathname.includes('/surveys/results/') && window.location.pathname.includes('/group-comparison')) {
        const id = window.location.pathname.split('surveys/results/')[1].split('/')[0];
        $backButton.attr('href', `/surveys/results/${id}`);
      }

      // Admin employees & teams back button
      $(document).ready(function () {
        let urlParams = new URLSearchParams(window.location.search);
        let destination = urlParams.get("destination");

        let currentPath = window.location.pathname;
        let currentPage = urlParams.get("page");

        // If the current page has a page parameter, store it
        if (currentPage) {
          sessionStorage.setItem("lastPage_" + currentPath, currentPage);
        } else {
          // If the current page does NOT have pagination, remove any stored page data
          sessionStorage.removeItem("lastPage_" + currentPath);
        }

        $(".back-link").on("click", function (e) {
          if (destination) {
            e.preventDefault();

            let decodedDestination = decodeURIComponent(destination);
            let destinationUrl = new URL(decodedDestination, window.location.origin);
            let destinationPath = destinationUrl.pathname;
            let destinationParams = new URLSearchParams(destinationUrl.search);

            // Retrieve stored page, but only use it if the destination has pagination
            let storedPage = sessionStorage.getItem("lastPage_" + destinationPath);
            if (storedPage && !destinationParams.has("page")) {
              destinationParams.set("page", storedPage);
            }

            let finalUrl = destinationPath + "?" + destinationParams.toString();
            window.location.href = finalUrl;
          }
        });
      });

      // Group reviews back button
      $(document).ready(function () {
        const currentPath = window.location.pathname;
        const urlParams = new URLSearchParams(window.location.search);
        const searchParam = urlParams.get("search");

        const targetPath = "/reviews/group-manager/all";
        const storageKey = "searchParam_" + targetPath;

        if (currentPath === targetPath) {
          if (searchParam) {
            sessionStorage.setItem(storageKey, searchParam);
          } else {
            sessionStorage.removeItem(storageKey);
          }
        }

        $(".back-link").on("click", function (e) {
          const storedSearch = sessionStorage.getItem(storageKey);

          let href = $(this).attr("href");
          if (href && href.includes(targetPath) && storedSearch && !href.includes("search=")) {
            e.preventDefault();

            const separator = href.includes("?") ? "&" : "?";
            const updatedHref = `${href}${separator}search=${encodeURIComponent(storedSearch)}`;

            window.location.href = updatedHref;
          }
        });
      });

      // Aio pages - back button redirection
      // $(document).ready(function () {
        // if ($("body").hasClass("path-aio-interface")) {
        //   $backButton.attr('href', '/');
        // }
        // if ($("body").hasClass("path-aio-sessions")) {
        //   $backButton.attr('href', '/');
        // }
      // });
      if (window.location.pathname.includes('/aio/sessions/')) {
        if ($backButton.data('referrer-path') && ($backButton.data('referrer-path').includes('/aio/sessions/') || $backButton.data('referrer-path').includes('/aio/sessions/'))) {
          $backButton.attr('href', 'javascript:history.go(-1)');
        } else {
          $backButton.attr('href', '/');
        }
      }
    }
  }

  Drupal.behaviors.hideTitleOnImageHover = {
    attach: function(context, settings) {
      ///// url - /insights/employees
      const $users = $('#edit-users');
      $users.each((i, el) => {
        const $user = $(el).find('tr').find('div.user-image[title]');
        $user.each((i, el) => {
          $(el).removeAttr('title');
        });
      });

      ///// url - /app/employees/527
      const $employerAvatar = $('.avatar__wrapper');
      const $img = $employerAvatar.find('div[title]');
      $img.removeAttr('title');

      //// url - /insights/teams/4/members
      const $usersMembers = $('#edit-team-members');
      $usersMembers.each((i, el) => {
        const $userLink = $(el).find('tr').find('> td > a[title]');
        $userLink.each((i, el) => {
          $(el).removeAttr('title');
        });

        const $userDiv = $(el).find('tr').find('> td > a > div[title]');
        $userDiv.each((i, el) => {
          $(el).removeAttr('title');
        });
      });

      ///// url - /meetings
      const $meetingOrganizer = $('.meeting__organizer [title]');
      $meetingOrganizer.removeAttr('title');

      ///// url - /meetings/details/19
      const $meetingAttendees = $('.meeting-details__attendees [title]');
      $meetingAttendees.removeAttr('title');

      ///// url - /profile notes
      const $notesUser = $('.path-profile .note__header [title]');
      $notesUser.removeAttr('title');

      ///// url - review/survey insights
      const $reviewer = $('.reviewer-wrapper > [title]');
      $reviewer.each((i, el) => {
        if (!$(el).closest('.user-additional-reviewer').length) {
          $(el).removeAttr('title');
        }
      });
    }
  }

  Drupal.behaviors.kpisMenu = {
    attach: function(context, settings) {
      const element = once('navigationBtn', '.main-navigation__button', context);
      const $element = $(element);

      const isInsightsPage = $element.closest('.path-insights').length;
      const $mainNavigation = $element.closest('.main-navigation');
      const $adminMenu = $mainNavigation.find('#block-insightsadminmenu');

      if (isInsightsPage && window.innerWidth < 1024) {
        $element.on('click', () => {
          $adminMenu.toggleClass('show-insights-menu');
          $element.toggleClass('active-btn');
        });
      }
    }
  }

  Drupal.behaviors.customLoader = {
    attach: function(context, settings) {
      const elements = $('a[href*="/insights/kpis"], a[href*="/okr?show_all=1"]');
      const elements2 = $('a[href*="/insights/surveys/dashboard"]:not(.use-ajax), .path-insights-surveys-dashboard input#edit-submit, .path-insights-surveys-dashboard input#edit-reset, a[href*="/surveys/insights"]:not(.use-ajax), .path-surveys-insights input#edit-submit, .path-surveys-insights input#edit-reset');
      const elements3 = $('a[href*="/insights/reviews"]:not(.use-ajax), .path-insights-reviews input#edit-submit, .path-insights-reviews input#edit-reset, a[href*="/insights/multi-review-analysis"]:not(.use-ajax), a[href*="/reviews/insights"]:not(.use-ajax), .path-reviews-insights input#edit-submit, .path-reviews-insights input#edit-reset');
      const elements4 = $('a[href$="/reviews"], a[href*="/reviews/my-reviews"], a[href*="/reviews/templates"], a[href$="/surveys"], a[href*="/surveys/my-surveys"], .search-section > input[type="submit"], body[class*="path-surveys-my-surveys-"] .form-filters input[type="submit"]');
      const elements5 = $('form.nn-feedback-feedback-create-form input.form-submit, form.nn-feedback-feedback-create-request-form input.form-submit, form.nn-comment-form-feedback-comment input.form-submit');
      const elements6 = $('form.nn-comment-form-review-question-comment input.form-submit');
      const elements7 = $('.aio-modal-block .aio_button a');

      elements.each((i, element) => {
        const $this = $(element);
        const $loader = $this.closest('body').find('.throbber-custom--flowit');

        $this.on('click', () => {
          $loader.addClass('show-loader');
        });
      })

      elements2.each((i, element) => {
        const $this = $(element);
        const $loader = $this.closest('body').find('.throbber-custom--ajax');

        $this.on('click', () => {
          $loader.addClass('show-loader-ajax');
        });
      })

      elements3.each((i, element) => {
        const $this = $(element);
        const $loader = $this.closest('body').find('.throbber-custom--ajax');

        $this.on('click', () => {
          $loader.addClass('show-loader-ajax');
        });
      })

      elements4.each((i, element) => {
        const $this = $(element);
        const $loader = $this.closest('body').find('.throbber-custom--ajax');

        $this.on('click', () => {
          $loader.addClass('show-loader-ajax');
        });
      })

      elements7.each((i, element) => {
        const $this = $(element);
        const $loader = $this.closest('body').find('.throbber-custom--ajax');

        $this.on('click', () => {
          $loader.addClass('show-loader-ajax');
        });
      })

      elements5.each((i, element) => {
        const $this = $(element);
        const $form = $this.closest('form');
        const $loader = $this.closest('body').find('.throbber-custom--ajax');

        $form.off('submit.customLoader').on('submit.customLoader', function (e) {
          if (this.checkValidity()) {
            $loader.addClass('show-loader-ajax');
          } else {
            $loader.removeClass('show-loader-ajax');
          }
        });
      });

      elements6.each((i, element) => {
        const $this = $(element);
        const $form = $this.closest('form');
        const $loader = $this.closest('body').find('.throbber-custom--ajax');

        $form.off('submit.customLoader').on('submit.customLoader', function (e) {
          if (this.checkValidity()) {
            $loader.addClass('show-loader-ajax');
          } else {
            $loader.removeClass('show-loader-ajax');
          }
        });
      });

      // Show flowit loader while download is in progress
      $(document).ready(function () {
        const $loader = $('.throbber-custom--ajax');

        // Handle clicks on .print-to-pdf (direct download)
        $(document).on('click', '.print-to-pdf:not(.use-ajax), #edit-download-csv-template', function (e) {
          e.preventDefault();

          const $this = $(this);
          if ($this.hasClass('downloading')) return;

          $this.addClass('downloading');
          $loader.addClass('show-loader-ajax');

          $.ajax({
            url: $this.attr('href'),
            method: 'GET',
            xhrFields: { responseType: 'blob' },
            success: function (data, status, xhr) {
              let filename = getFilenameFromHeader(xhr);

              // Create a temporary download link
              let link = document.createElement('a');
              let blobUrl = URL.createObjectURL(data);
              link.href = blobUrl;
              link.download = filename;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              URL.revokeObjectURL(blobUrl);

              $loader.removeClass('show-loader-ajax');
            },
            error: function () {
              $loader.removeClass('show-loader-ajax');
            },
            complete: function () {
              $this.removeClass('downloading');
            }
          });
        });

        // Handle clicks inside the modal (.print-pdf-button)
        $(document).on('click', '.print-pdf-button', function (e) {
          e.preventDefault();

          const $this = $(this);
          if ($this.hasClass('downloading')) return;

          $this.addClass('downloading').prop('disabled', true);
          const $form = $this.closest('form');
          if (!$form.length) return;

          $loader.addClass('show-loader-ajax');

          $.ajax({
            url: $form.attr('action'),
            method: 'POST',
            data: $form.serialize(),
            xhrFields: { responseType: 'blob' },
            success: function (data, status, xhr) {
              let filename = getFilenameFromHeader(xhr);

              let link = document.createElement('a');
              let blobUrl = URL.createObjectURL(data);
              link.href = blobUrl;
              link.download = filename;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              URL.revokeObjectURL(blobUrl);

              $loader.removeClass('show-loader-ajax');
              $('.ui-dialog-titlebar-close').click();
            },
            error: function () {
              $loader.removeClass('show-loader-ajax');
            },
            complete: function () {
              $this.removeClass('downloading').prop('disabled', false);
            }
          });
        });

        // Helper function to extract filename from Content-Disposition header
        function getFilenameFromHeader(xhr) {
          let filename = 'download.pdf'; // Default filename
          let disposition = xhr.getResponseHeader('Content-Disposition');
          if (disposition && disposition.includes('filename=')) {
            let matches = disposition.match(/filename="?([^"]+)"?/);
            if (matches && matches.length > 1) {
              filename = matches[1];
            }
          }
          return filename;
        }
      });

      const $editPeriod = $('.nn-surveys-multi-review-analysis [id*=edit-period]');
      const $submit = $('.nn-surveys-multi-review-analysis [id*=edit-submit]');

      $editPeriod.on('select2:select', () => {
        if ($editPeriod.val() != '') {
          const $loader = $submit.closest('body').find('.throbber-custom--ajax');

          $submit.on('click', () => {
            $loader.addClass('show-loader-ajax');
          });
        } else {
          $submit.unbind('click');
        }
      });
    }
  }

  Drupal.behaviors.surveysOnly = {
    attach: function(context, settings) {
      const $popup = $('<div class="surveys-only-message"><div class="surveys-only-message__close"></div><p>' + Drupal.t('Your subscription does not include this feature.') + '</p></div>');

      const elements = once('surveysOnly', '.navigation a.disabled', context);

      elements.forEach((element) => {
        const $this = $(element);

        $this.on('click', (e) => {
          e.preventDefault();
          $popup.insertBefore($this);
          $popup.addClass('show-message');

          const $close = $this.prev().find('.surveys-only-message__close');
          $close.on('click', () => {
            $popup.removeClass('show-message');
          });
        });
      });
    }
  }

  Drupal.behaviors.skillsCharts = {
    attach: function(context, settings) {
      const $skill = $('.top-skills-item, .skill-item, .review-response-rate__wrapper');

      $skill.each((i, el) => {
        // value
        const $circle = $(el).find('circle.value');

        if ($circle.length && $circle[0].getClientRects().length) {
          const value = $(el).find('span[data-value]').data('value');
          const strokeDasharray = $circle[0].getTotalLength();
          const strokeDashoffset = strokeDasharray - (strokeDasharray * value / 100);

          $circle.css('stroke-dasharray', strokeDasharray);
          $circle.css('stroke-dashoffset', strokeDashoffset);
        }

        // potential
        const $circlePotential = $(el).find('circle.potential');
        if ($circlePotential.length && $circlePotential[0].getClientRects().length) {
          const potential = $(el).find('div[data-potential]').data('potential');
          const strokeDasharrayPotential = $circlePotential[0].getTotalLength();
          const strokeDashoffsetPotential = strokeDasharrayPotential - (strokeDasharrayPotential * potential / 100);

          $circlePotential.css('stroke-dasharray', strokeDasharrayPotential);
          $circlePotential.css('stroke-dashoffset', strokeDashoffsetPotential);
        }
      });
    }
  }

  Drupal.behaviors.expandDescription = {
    attach: function(context, settings) {
      const elements = once('expandDescription', 'span.expand-description', context);

      elements.forEach((element) => {
        const $this = $(element);

        $this.on('click', () => {
          $this.toggleClass('active');
          $this.closest('article').find('.field--name-description').slideToggle('fast');
        });
      });
    }
  }

  Drupal.behaviors.chartsExpandButton = {
    attach: function(context, settings) {

      const $page = $('.path-app-skill-manager, .path-app-role-comparison, .profile__skill-ideal-role-profile');

      if ($page.length) {
        const elements = once('chartsExpandButton', '.skill-items', context);

        elements.forEach((element) => {
          const $this = $(element);

          const $items = $this.find('.skill-item');

          let heights = [];

          $items.each((i, element) => {
            if (i < 3) {
              heights.push($(element).outerHeight());
            }
          });

          const maxHeight = Math.max(...heights);

          const height = $this.outerHeight();
          const $expandButton = $this.next('.more-link');

          if (height > 350) {
            $this.addClass('collapse');
            $this.css('max-height', maxHeight + 'px')
            $expandButton.removeClass('hidden');
          }

          $expandButton.on('click', () => {
            if ($this.hasClass('collapse')) {
              $this.css('max-height', 'initial');
              $this.removeClass('collapse');
            } else {
              $this.css('max-height', maxHeight + 'px');
              $this.addClass('collapse');
            }

            $expandButton.toggleClass('less');

            if ($expandButton.text() == Drupal.t('Show more')) {
              $expandButton.text(Drupal.t('Show less'));
            } else {
              $expandButton.text(Drupal.t('Show more'));
            }
          })
        });

        $('.skill-type-wrapper').each((i, el) => {
          $(el).find('.collapse').removeClass('collapse');
          $(el).find('.skill-items').css({
            'max-height': 'initial'
          })
        })
      }
    }
  }

  Drupal.behaviors.customSelect = {
    attach: function(context, settings) {

      const $selectElements = $('select');
      const $selectMaxProgress = $('body[class*=path-objective] select[id*=edit-max-progress]');
      const $selectEditOwner = $('.ui-dialog [data-drupal-selector=edit-owner]');
      const $selectUpdateFrequency = $('[id*=edit-update-frequency]');
      const $selectAssociatedTeam = $('select#edit-associated-team')
      const $webformSelect = $('.webform-submission-form .question__input-wrapper select');
      const $scaleSelect = $('.scale-select');

      $selectElements.each((i, el) => {
        if (!$(el).closest('.flatpickr-calendar').length) {
          $(el).select2();
        }
      });

      $selectMaxProgress.select2({
        dropdownCssClass: 'show-search',
        dropdownParent: $('form.ed-okr-manage-key-result')
      });

      $selectEditOwner.select2({
        dropdownParent: $('form.ed-okr-manage-key-result')
      });

      $selectUpdateFrequency.select2({
        dropdownParent: $('form.ed-okr-manage-key-result')
      });

      $selectAssociatedTeam.select2({
        dropdownParent: $('.form-item-associated-team')
      });

      $webformSelect.select2({
        dropdownParent: $webformSelect.parent()
      });

      $scaleSelect.each(function () {
        $(this).select2({
          minimumResultsForSearch: Infinity
        });
      });

      // $selectEmployeeSelectParticipant.select2({
      //   sorter: data => data.sort((a, b) => a.text.localeCompare(b.text)),
      // });

      /**
       * Disable review type Start
       */
      const comingSoonText = Drupal.t('Coming soon');

      const $disableReviewTypeOption = $('option[value=repeated_review], option[value=specific_event_review]');
      $disableReviewTypeOption.each((i, el) => {
        $(el).prop('disabled', true);
      });

      $('select#edit-review-type').on('select2:open', () => {
        setTimeout(() => {
          $('.select2-results__option--disabled').attr('data-coming-soon', comingSoonText)
        }, 500);
      });
      /**
       * Disable review type End
       */
    }
  }

  Drupal.behaviors.mainTabsRelocation = {
    attach: function(context, settings) {
      const $mainTabs = $('body.path-insights-reviews #edit-tabs, body.path-insights-multi-review-analysis #edit-tabs, body[class*="path-insights-multi-review-analysis-"] #edit-main-tabs, body[class*="-pain-points"] .form-item-main-tabs, body[class*="-management-summary"] .form-item-main-tabs');
      $mainTabs.detach().prependTo('body.path-insights-reviews #block-flowit-content, body.path-insights-multi-review-analysis #block-flowit-content, body[class*="-overview"] #block-flowit-content, body[class*="-pain-points"] .region-content, body[class*="-management-summary"] .region-content');
    }
  }

  Drupal.behaviors.removeImageButtonContainer = {
    attach: function(context, settings) {
      const element = once('removeImage', 'input[id*="-remove-button"]', context);

      $(element).wrap('<div class="remove-button-container"></div>');
    }
  }

  Drupal.behaviors.graphTooltip = {
    attach: function(context, settings) {
      const $employee = $('.skill-manager__employee, .role-comparison__role, .top-skills-items');
      const $label = $employee.find('.skill-item > label > span, .top-skills-item > label > span');

      $label.each((i, el) => {
        $(el).css('max-width', 'initial');

        if ($(el).outerWidth() > 140) {
          $(el).addClass('add-tooltip');
        }

        $(el).css('max-width', '140px');
      })
    }
  }

  Drupal.behaviors.customTooltip = {
    attach: function(context, settings) {
      $('[title]').each((i, el) => {
        // filters - remove tooltip
        if ($(el).closest($('[id*=edit-filters]')).length) {
          $(el).removeAttr('title');
        }

        // remove double tooltip
        if ($(el).attr('title') == $(el).find('> [title]').attr('title')) {
          $(el).removeAttr('title');
        }

        // pagination - remove tooltip
        if ($(el).closest($('nav.pager')).length) {
          $(el).removeAttr('title');
        }

        // remove tooltip from select element
        if ($(el).closest($('.select2-container')).length) {
          $(el).removeAttr('title');
        }

        // remove tooltip from evaluations settings
        if ($(el).closest($('.form-item-evaluation-period-next-start-date')).length) {
          $(el).removeAttr('title');
        }

        $(el).tooltipster({
          delay: '0',
          theme: 'my-custom-theme',
          position: $(el).hasClass('tooltip-bottom') ? 'bottom' : 'top',
        });
      });

      // remove tooltip from select element on select
      const elements = once('selectRemoveTooltip', 'select', context);

      elements.forEach((element) => {
        const $this = $(element);

        $this.on('select2:select', () => {
          if ($('[title]').closest($('.select2-container')).length) {
            $('[title]').removeAttr('title');
          }
        });
      });

      //remove tooltip from button in modal
      // $.ajax().done(() => {
      //   $('.ui-button').removeAttr('title');
      // });
    }
  }

  Drupal.behaviors.importCsvCloud = {
    attach: function(context, settings) {
      const $uploadCsv = $('.upload-csv-container');
      const $table = $uploadCsv.find('table');

      if ($table.length) {
        $uploadCsv.addClass('upload-csv-container--no-icon');
      }
    }
  }

  Drupal.behaviors.removeAlt = {
    attach: function(context, settings) {
      const $img = $('img');

      $img.each((i, el) => $(el).removeAttr('alt'));
    }
  }

  Drupal.behaviors.disableContextMenuModal = {
    attach: function(context, settings) {
      const $modal = $('[data-dialog-type="modal"]');

      $modal.each((i, el) => {
        $(el).on('contextmenu', () => {
          return false;
        });
      });
    }
  }

  Drupal.behaviors.customRangeSlider = {
    attach: function(context, settings) {

      const isPages = $('body[class*="-skills-add"], body[class*="-add-evaluation"], body[class*="path-app-role-"], body[class*=path-objective], .path-okr, .path-okr-archive').length;

      if (isPages) {
        const elements = once('customRangeSlider', 'input[type=range]', context);

        elements.forEach((element) => {
          const $this = $(element);

          $this.parent().prepend('<output class="js-output hidden">' + $this.val() + '</output>');

          $this.siblings('.js-output.hidden').insertBefore($this);

          $this.on('input',() => {
            $this.prev('.js-output').text($this.val());
            $this.attr('value', $this.val());
          });
        });
      }
    }
  }

  Drupal.behaviors.mobileMenu = {
    attach: function(context, settings) {
      const element = once('navBtn', '#nav-menu-btn', context);
      const $navBtn = $(element);

      $navBtn.on('click', () => {
        $navBtn.toggleClass('hide');
        $navBtn.closest('nav.main-navigation').toggleClass('show')
      })
    }
  }

  Drupal.behaviors.navigationNoIcons = {
    attach: function(context, settings) {
      const $engagement = $('.icon--engagement');
      const $performance = $('.icon--performance');

      function hideIcons(container) {
        const links = container.find('li').length;
        const linksDisabled = container.find('li.disabled').length;

        if (links == linksDisabled) {
          container.addClass('no-icon');
        }
      }

      hideIcons($engagement);
      hideIcons($performance);
    }
  }

  Drupal.behaviors.translations = {
    attach: function(context, settings) {
      /**
       * Global
       */
      // @TODO test
      const $messageTranslated = $('.translated-text');
      const buttonTranslation = once('buttonTranslation', '.button--translation', context);
      const buttonOriginal = once('buttonOriginal', '.button--original', context);

      if ($messageTranslated.length && $messageTranslated.is(':visible')) {
        $messageTranslated.next('.original-text').hide();
      } else {
        $messageTranslated.next('.original-text').show();
      }

      buttonOriginal.forEach((element) => {
        const $this = $(element);

         $this.on('click', () => {
          if ($this.closest('.translated-text').next('.original-text').length) {
            $this.closest('.translated-text').hide();
            $this.closest('.translated-text').next('.original-text').show();
          }
        });
      });

      buttonTranslation.forEach((element) => {
        const $this = $(element);

        $this.on('click', () => {
          if ($this.closest('.original-text').prev('.translated-text').length) {
            $this.closest('.original-text').hide();
            $this.closest('.original-text').prev('.translated-text').show();
          }
        });
      });

      /**
       * Review results - summary comments
       */

      function textareaHeight() {
        const $textarea = document.querySelectorAll('.my-reviews-wrapper textarea');
        $textarea.forEach((element) => {
          element.style.height = element.scrollHeight + 'px';
        });
      }

      const $messageTranslatedNoteForm = $('.reviews-note-form textarea[id*=translation-review-note]');
      const $buttonTranslationNoteForm = $('.reviews-note-form .button--translation');
      const $buttonOriginalNoteForm = $('.reviews-note-form .button--original');

      if ($messageTranslatedNoteForm.length && $messageTranslatedNoteForm.is(':visible')) {
        $messageTranslatedNoteForm.closest('[class*=translation-review-note].form-type-textarea').next().next('[class*=original-review-note].form-type-textarea').hide();
        $messageTranslatedNoteForm.closest('[class*=translation-review-note].form-type-textarea').next().next().next('[class*=original-see-translation].form-type-item').hide();
      } else {
        $messageTranslatedNoteForm.closest('[class*=translation-review-note].form-type-textarea').next().next('[class*=original-review-note].form-type-textarea').show();
        $messageTranslatedNoteForm.closest('[class*=translation-review-note].form-type-textarea').next().next().next('[class*=original-see-translation].form-type-item').show();
      }

      $buttonOriginalNoteForm.each((i, el) => {
        const $el = $(el);

        $el.on('click', () => {
          if ($el.closest('[class*=translation-see-original].form-type-item').next('[class*=original-review-note].form-type-textarea').length) {
            $el.closest('[class*=translation-see-original].form-type-item').hide();
            $el.closest('[class*=translation-see-original].form-type-item').prev('[class*=translation-review-note].form-type-textarea').hide();

            $el.closest('[class*=translation-see-original].form-type-item').next('[class*=original-review-note].form-type-textarea').show();
            $el.closest('[class*=translation-see-original].form-type-item').next().next('[class*=original-see-translation].form-type-item').show();

            textareaHeight();
          }
        });
      });

      $buttonTranslationNoteForm.each((i, el) => {
        const $el = $(el);

        $el.on('click', () => {
          if ($el.closest('[class*=original-see-translation].form-type-item').prev().prev().prev('[class*=translation-review-note].form-type-textarea').length) {
            $el.closest('[class*=original-see-translation].form-type-item').hide();
            $el.closest('[class*=original-see-translation].form-type-item').prev('[class*=original-review-note].form-type-textarea').hide();

            $el.closest('[class*=original-see-translation].form-type-item').prev().prev('[class*=translation-see-original].form-type-item').show();
            $el.closest('[class*=original-see-translation].form-type-item').prev().prev().prev('[class*=translation-review-note].form-type-textarea').show();

            textareaHeight();
          }
        });
      });
    }
  }

  Drupal.behaviors.uploadBatchError = {
    attach: function(context, settings) {
      const $message = $('div[data-drupal-messages] .messages--error div');

      const $messageText = $message.text().toLowerCase();
      const stringEN = 'No active batch'.toLowerCase();
      const stringDE = 'Keine aktive Batch'.toLowerCase();

      if ($messageText.includes(stringEN) || $messageText.includes(stringDE)) {
        $message.closest('.messages--error').hide();
      }
    }
  }

  Drupal.behaviors.countryCodeMobile = {
    attach: function(context, settings) {
      /**
       * Edit Profile, Create/Edit Employee
       */

      // mobile phone container
      const countryCodeField = once('countryCodeFile', '.phone-number-input-wrapper div[class*="-country-code"].form-type-select', context);
      const $countryCodeField = $(countryCodeField);
      const $container = $('.phone-number-input-wrapper');
      const $mobileField = $container.find('div[class*="-mobile"].form-type-textfield');
      const $verified = $container.find('div.form-item.verified');

      $countryCodeField.wrap('<div class="mobile-container"></div>');
      const $mobileContainer = $countryCodeField.closest('.mobile-container');

      if ($mobileField.length && $mobileContainer.length) {
        $mobileField.detach().appendTo($mobileContainer);
      }

      if ($verified.length && $mobileContainer.length) {
        $verified.detach().appendTo($mobileContainer);
      }

      // clean country code
      function cleanCountryCode () {
        const $countrySelectValue = $('.phone-number-input-wrapper .select2-selection__rendered');

        if ($countrySelectValue.text().includes('(')) {
          const getPrefix = $countrySelectValue.text().split('(')[1].split(')')[0];
          $countrySelectValue.text(getPrefix);
        }
      }

      cleanCountryCode();

      // $.ajax().done(() => {
      //   cleanCountryCode();
      // });

      const countryCode = once('countryCode', 'select.country.form-select', context);
      const $countryCode = $(countryCode);
      $countryCode.on('select2:select', cleanCountryCode);
    }
  }

  Drupal.behaviors.languageSwitcher = {
    attach: function(context, settings) {
      const element = once('languageSwitcher', '.language-switcher-dropdown', context);
      const $element= $(element);

      $element.on('mouseenter', () => $element.prev().addClass('active-hover'));
      $element.on('mouseleave', () => $element.prev().removeClass('active-hover'));

      const $current = $element.prev('.language-switcher-current');
      const language = $('html').attr('lang');
      const languages = ['DE', 'FR', 'IT', 'EN', 'PT-PT', 'ES'];

      if ($current.length) {
        const value = $current.text();
        if (value === 'PT-PT') {
          $current.text('PT');
        }
        if (!languages.includes(value) ) {
          if (language == 'pt-pt') {
            $current.text('PT');
          }
          else {
            $current.text(language.toUpperCase());
          }
        }
      }

      // Mobile: toggle the dropdown on click instead of relying on :hover,
      // which only opens on tap but never closes on a second tap.
      const isMobile = () => window.innerWidth < 768;

      $current.on('click', (e) => {
        if (!isMobile()) {
          return;
        }

        e.stopPropagation();
        $current.toggleClass('opened');
      });

      // close the dropdown when clicking outside of it
      const body = once('languageSwitcherClickOutside', 'body', context);
      $(body).on('click', (e) => {
        if (isMobile() && !$(e.target).closest('.language-dropdown-wrapper').length) {
          $current.removeClass('opened');
        }
      });
    }
  }

  Drupal.behaviors.clearStorage = {
    attach: function(context, settings) {
      const notFeedbackCreatePage = once('clearStorage', 'body:not([class*="path-instant-feedback-create"])', context);
      const $notFeedbackCreatePage = $(notFeedbackCreatePage);
      const isNotFeedbackCreatePage = $notFeedbackCreatePage.length;
      const value = $('.create-feedback-clear-storage').attr('value');
      const url = Drupal.url('instant-feedback/clear');

      if (value) {
        window.sessionStorage.setItem('feedbackUserId', value);
      }

      if (isNotFeedbackCreatePage) {
        const data = {
          id: value
        }

        const feedbackUserId = window.sessionStorage.getItem('feedbackUserId');
        if (feedbackUserId) {
          navigator.sendBeacon(url, data);
          window.sessionStorage.removeItem('feedbackUserId');
        }
      }
    }
  }

  Drupal.behaviors.loadPage = {
    attach: function(context, settings) {
      if (!$('body').find('form.nn-surveys-surveys-analysis-dashboard').length) {
        $('body[data-body]').addClass('loaded');
        $('.throbber-custom').addClass('hide-loader');
      }
    }
  }

  Drupal.behaviors.scrollToAnchor = {
    attach: function (context, settings) {

      // Run only once per page load
      if (window.__scrollToAnchorRan) {
        return;
      }
      window.__scrollToAnchorRan = true;

      jQuery(document).ready(function ($) {

        // ⬇️ Replace window.load with small delay
        setTimeout(function () {

          const hash = window.location.hash;

          if (hash && $(hash).length) {
            const $target = $(hash);
            const headerOffset = 100;

            const scrollToTarget = () => {
              const scrollTop = $target.offset().top - headerOffset;
              $('html, body').stop(true).animate({ scrollTop: scrollTop }, 300);
            };

            let animationsPending = 0;

            const afterAnimation = function () {
              animationsPending--;
              if (animationsPending <= 0) {
                setTimeout(scrollToTarget, 50);
              }
            };

            const $parentArticle = $target.closest('article').closest('article[id^="o-"]');
            if ($parentArticle.length) {
              const $expandOption = $parentArticle.find('span.expand-option');
              if ($expandOption.length) {
                $expandOption.addClass('active');
              }

              const $keyResult = $parentArticle.find('article.key-result--view-mode-compact');
              if ($keyResult.length && $keyResult.is(':hidden')) {
                animationsPending++;
                $keyResult.stop(true, true).slideDown('fast', afterAnimation);
              }
            }

            const $teamContainer = $target.closest('.team[id^="edit-"]');
            if ($teamContainer.length) {
              const $teamDetails = $teamContainer.find('div[id*="edit-objectives-header"], div[id*="edit-objectives"]');
              const $teamExpandOption = $teamContainer.find('.team-actions .expand-option');
              if ($teamExpandOption.length) {
                $teamExpandOption.addClass('active');
              }

              if ($teamDetails.length && $teamDetails.is(':hidden')) {
                animationsPending++;
                $teamDetails.stop(true, true).slideDown('fast', afterAnimation);
              }
            }

            // Initial scroll
            scrollToTarget();

            // Final adjustment
            if (animationsPending === 0) {
              setTimeout(scrollToTarget, 50);
            }
          } else {
            const teamId = new URLSearchParams(window.location.search).get('team');
            const $team = teamId ? $('#edit-' + teamId) : $();

            if ($team.length) {
              const headerOffset = 100;

              const scrollToTeam = () => {
                const scrollTop = $team.offset().top - headerOffset;
                $('html, body').stop(true).animate({ scrollTop: scrollTop }, 300);
              };

              const $teamDetails = $team.find('div[id*="edit-objectives-header"], div[id*="edit-objectives"]');

              if ($teamDetails.length && $teamDetails.is(':visible')) {
                scrollToTeam();
              } else {
                $(document).one('ajaxComplete', function () {
                  setTimeout(scrollToTeam, 100);
                });

                $team.find('.team-click').trigger('click');

                setTimeout(scrollToTeam, 400);
              }
            }
          }
        }, 100);
      });
    }
  };

  Drupal.behaviors.statusBadgeRelocation = {
    attach: function(context, settings) {
      $('.reviews-insights-form .reviewer-wrapper, .surveys-insights-form .reviewer-wrapper').each(function() {
        const $completedBadge = $(this).find('.completed');
        const $uncompletedBadge = $(this).find('.uncompleted');
        const $draftBadge = $(this).find('.draft');
        const $userImageDiv = $(this).find('.user-image');

        if ($userImageDiv.length) {
          if ($uncompletedBadge.length) {
            $userImageDiv.append($uncompletedBadge);
          }
          if ($completedBadge.length) {
            $userImageDiv.append($completedBadge);
          }
          if ($draftBadge.length) {
            $userImageDiv.append($draftBadge);
          }
        }
      });
    }
  }

  Drupal.behaviors.errorClassRelocation = {
    attach: function (context, settings) {
      let formSubmitted = false;
      let scrolledToError = false;
      const $modalSubmit = $('.path-surveys .confirm-submission-form .confirm-submit, .path-reviews .confirm-submission-form .confirm-submit');

      function setContainerError($field, hasError) {
        const $container = $field.closest('.question-wrapper-container');
        if (!$container.length) {
          return;
        }

        if (hasError) {
          $field.addClass('error');
          $container.addClass('error');
        } else {
          $field.removeClass('error');
          $container.removeClass('error');
        }
      }

      function relocateErrorClass() {
        $('.question__input-wrapper textarea.error, .question__input-wrapper input.error', context).each(function () {
          const parentContainer = $(this).closest('.question-wrapper-container');
          if (parentContainer.length) {
            parentContainer.addClass('error');
          }
        });

        if (formSubmitted && !scrolledToError && $('.question-wrapper-container.error').length) {
          setTimeout(scrollToFirstError, 100);
        }
      }

      function syncLabelErrorState() {
        $('.question-wrapper-container').each(function () {
          const $wrapper = $(this);
          const $label = $wrapper.find('.question__title-wrapper .form-element-label');

          if ($label.length) {
            if ($wrapper.hasClass('error')) {
              $label.addClass('error');
            } else {
              $label.removeClass('error');
            }
          }
        });
      }

      function validateConditionalCounters($specificField = null) {
        let hasViolation = false;

        const $fields = $(
          '.question__input-wrapper textarea[data-counter-minimum], ' +
          '.question__input-wrapper textarea[data-counter-maximum], ' +
          '.question__input-wrapper input[data-counter-minimum], ' +
          '.question__input-wrapper input[data-counter-maximum]',
          context
        );

        const fieldsToCheck = $specificField ? $specificField : $fields;

        $(fieldsToCheck).each(function () {
          const $field = $(this);
          const value = ($field.val() || '').toString().trim();

          const minAttr = parseInt($field.attr('data-counter-minimum'), 10);
          const maxAttr = parseInt($field.attr('data-counter-maximum'), 10);
          const type = $field.attr('data-counter-type') || 'character';

          let isValid = true;
          let count = 0;

          if (type === 'word') {
            count = value.length ? value.split(/\s+/).length : 0;
          } else {
            count = value.length;
          }

          if (!isNaN(minAttr) && count < minAttr) {
            isValid = false;
          }

          if (!isNaN(maxAttr) && count > maxAttr) {
            isValid = false;
          }

          if ($field.prop('required') && count === 0) {
            isValid = false;
          }

          if (!isValid) {
            setContainerError($field, true);
            hasViolation = true;
          } else {
            setContainerError($field, false);
          }
        });

        syncLabelErrorState();
        return hasViolation;
      }

      // function validateMaxOptions() {
      //   let hasViolation = false;

      //   $('fieldset[data-max-options]', context).each(function () {
      //     const $fieldset = $(this);
      //     const maxOptions = parseInt($fieldset.attr('data-max-options'), 10) || 0;
      //     const checkedCount = $fieldset.find('input[type="checkbox"]:checked').length;

      //     const parentContainer = $fieldset.closest('.question-wrapper-container');
      //     const $target = parentContainer.length ? parentContainer : $fieldset;

      //     if (maxOptions > 0 && checkedCount > maxOptions) {
      //       $target.addClass('error');
      //       hasViolation = true;
      //     } else {
      //       $target.removeClass('error');
      //     }

      //     syncLabelErrorState();
      //   });

      //   return hasViolation;
      // }

      function validateMaxOptions() {
        let hasViolation = false;

        $('fieldset[data-max-options]', context).each(function () {
          const $fieldset = $(this);
          const maxOptions = parseInt($fieldset.attr('data-max-options'), 10) || 0;
          const checkedCount = $fieldset.find('input[type="checkbox"]:checked').length;

          const isRequired = $fieldset.find('.form-checkboxes[required], .form-checkboxes[required="required"]').length > 0
            || $fieldset.attr('required') === 'required';

          const parentContainer = $fieldset.closest('.question-wrapper-container');
          const $target = parentContainer.length ? parentContainer : $fieldset;

          let hasError = false;

          if (isRequired && checkedCount === 0) {
            hasError = true;
          }

          if (maxOptions > 0 && checkedCount > maxOptions) {
            hasError = true;
          }

          if (hasError) {
            $target.addClass('error');
            hasViolation = true;
          } else {
            $target.removeClass('error');
          }
        });

        syncLabelErrorState();
        return hasViolation;
      }

      function scrollToFirstError() {
        if (scrolledToError) return;

        const $firstError = $('.question-wrapper-container.error').first();
        if ($firstError.length) {
          const offset = $firstError.offset().top - 100;
          $('html, body').stop(true).animate({ scrollTop: offset }, 250);
          scrolledToError = true;
        }
      }

      $(document).ready(() => {
        validateConditionalCounters();
        validateMaxOptions();
        relocateErrorClass();
      });

      $(document).on(
        'input keyup paste',
        '.question__input-wrapper textarea, .question__input-wrapper input:not([type="checkbox"])',
        function () {
          validateConditionalCounters($(this));
        }
      );

      $(document).on(
        'change',
        '.question__input-wrapper textarea, .question__input-wrapper input:not([type="checkbox"])',
        function () {
          validateConditionalCounters($(this));
        }
      );

      $(document).on('change', 'fieldset[data-max-options] input[type="checkbox"]', function () {
        validateMaxOptions();
      });

      $modalSubmit.on('click', (e) => {
        if ($('.question-wrapper-container.error').length) {
          e.preventDefault();
          setTimeout(scrollToFirstError, 100);
        }
      });

      $('form.webform-submission-form').on('submit', function (e) {
        const isDraft = $(document.activeElement).hasClass('webform-button--draft');

        if (isDraft) {
          return true;
        }

        formSubmitted = true;
        localStorage.setItem('formSubmitted', 'true');
        relocateErrorClass();

        if ($('.question-wrapper-container.error').length) {
          e.preventDefault();
          setTimeout(scrollToFirstError, 100);
        }
      });

      if (localStorage.getItem('formSubmitted') === 'true') {
        localStorage.removeItem('formSubmitted');
        $(document).ready(() => {
          setTimeout(scrollToFirstError, 100);
        });
      }
    }
  };

  Drupal.behaviors.completionDueDateValidation = {
    attach: function(context, settings) {
      const endDate = once('endDate', '#edit-scheduling-wrapper-fill-in-period-wrapper-fill-in-period-end-date', context);
      const $endDate = $(endDate);

      function setMinDate(date, isOnChange) {
        const endDateValue = new Date(date).toISOString().split('T')[0];
        const nextDate = new Date(endDateValue).setDate(new Date(endDateValue).getDate() + 1);
        const nextDateFormat = new Date(nextDate).toISOString().split('T')[0];
        const $completionDueDateInput = $('input#edit-scheduling-wrapper-completion-due-date-wrapper-completion-due-date-date');

        $completionDueDateInput.flatpickr({
          minDate: new Date(nextDateFormat)
        })

        if (isOnChange) {
          const completionDateValue = $endDate.closest('form').find($completionDueDateInput).val();
          const endDateValue = $endDate.val();

          const isInvalid = validateDates(endDateValue, completionDateValue);

          if (isInvalid) {
            $completionDueDateInput.val(nextDateFormat);
          }
        }
      }

      function validateDates(p1, p2) {
        if (new Date(p1) > new Date(p2)) {
          return true;
        } else {
          return false;
        }
      }

      if ($endDate.length) {
        if ($endDate.val()) {
          setTimeout(() => {
            setMinDate($endDate.val());
          }, 500)
        }

        $endDate.on('change', (e) => {
          setMinDate(e.target.value, true);
        })
      }

      const getTranslatedLocale = () => ({
        firstDayOfWeek: 1,
        weekdays: {
          shorthand: settings.datesLocale.weekdays.shorthand.map(String),
          longhand: settings.datesLocale.weekdays.longhand.map(String),
        },
        months: {
          shorthand: settings.datesLocale.months.shorthand.map(String),
          longhand: settings.datesLocale.months.longhand.map(String),
        }
      });

      // Review automations - validity end date input
      $('.form-item-validity-period-end-date input.flowit-flatpickr-date-create-review', context).each(function () {
        if (this._flatpickr) {
          this._flatpickr.destroy();
        }

        flatpickr(this, {
          altInput: true,
          altFormat: "d.m.Y",
          dateFormat: "Y-m-d",
          minDate: "today",
          locale: getTranslatedLocale()
        });
      });
    }
  }

  Drupal.behaviors.toggleReviewsGroupActions = {
    attach: function (context, settings) {
      jQuery(document).ready(function ($) {

        function handlePdfDownload($link, $loader) {
          if ($link.hasClass('downloading')) return;

          $link.addClass('downloading');
          $loader.addClass('show-loader-ajax');

          $.ajax({
            url: $link.attr('href'),
            method: 'GET',
            xhrFields: { responseType: 'blob' },
            success: function (data, status, xhr) {
              let filename = 'download.pdf';
              const disposition = xhr.getResponseHeader('Content-Disposition');
              if (disposition && disposition.includes('filename=')) {
                const matches = disposition.match(/filename="?([^"]+)"?/);
                if (matches && matches.length > 1) {
                  filename = matches[1];
                }
              }

              const blobUrl = URL.createObjectURL(data);
              const link = document.createElement('a');
              link.href = blobUrl;
              link.download = filename;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              URL.revokeObjectURL(blobUrl);
            },
            error: function () {
              // Optional error handling
            },
            complete: function () {
              $loader.removeClass('show-loader-ajax');
              $link.removeClass('downloading');
            }
          });
        }

        function attachEditDropdownHandlers() {
          $(".reviews-group__actions-wrapper .surveys-list__action-links > a", context).off("click").on("click", function (e) {
            e.stopPropagation();

            $(".surveys-list__additional-info__list.active", context).removeClass("active");

            const $wrapper = $(this).closest(".reviews-group-item__wrapper");
            const $dropdown = $wrapper.find(".dropdown-menu");

            $(".reviews-group__actions-wrapper .dropdown-menu").not($dropdown).removeClass("active");
            $dropdown.toggleClass("active");
          });
        }

        function attachEditDropdownHandlers2() {
          $(".surveys-list__top-right .surveys-list__action-links", context).off("click").on("click", function (e) {
            e.stopPropagation();

            $(".surveys-list__additional-info__list.active", context).removeClass("active");

            const $wrapper = $(this).closest(".surveys-survey-item__wrapper");
            const $dropdown = $wrapper.find(".item-list");

            $(".surveys-list__top-right .item-list").not($dropdown).removeClass("active");
            $dropdown.toggleClass("active");

            $(".surveys-list__action-links .item-list", context).off("click").on("click", function (e) {
              e.stopPropagation();

              const $target = $(e.target);

              if ($target.is('.print-to-pdf')) {
                e.preventDefault();
                const $loader = $('.throbber-custom--ajax');
                handlePdfDownload($target, $loader);
              }
            });
          });
        }

        function attachAdditionalInfoHandlers() {
          $(".surveys-list__additional-info", context).off("click").on("click", function (e) {
            e.stopPropagation();

            $(".surveys-list__action-links .dropdown-menu.active", context).removeClass("active");
            $(".surveys-list__action-links .item-list.active", context).removeClass("active");

            const $list = $(this).find(".surveys-list__additional-info__list");

            $(".surveys-list__additional-info__list").not($list).removeClass("active");
            $list.toggleClass("active");
          });

          $(".surveys-list__additional-info__list", context).off("click").on("click", function (e) {
            e.stopPropagation();
          });
        }

        function toggleAdditionalInfo() {
          $(".surveys-list__top-right .surveys-list__toggler", context).off("click").on("click", function (e) {
            e.stopPropagation();

            const $wrapper = $(this).closest(".surveys-survey-item__wrapper");
            const $dropdown = $wrapper.find(".surveys-list__details-wrapper");
            const $toggleButton = $wrapper.find(".surveys-list__toggler");

            $(".surveys-list__details-wrapper").not($dropdown).removeClass("active");
            $dropdown.toggleClass("active");

            $(".surveys-list__toggler").not($toggleButton).removeClass("active");
            $toggleButton.toggleClass("active");
          });
        }

        attachEditDropdownHandlers();
        attachEditDropdownHandlers2();
        attachAdditionalInfoHandlers();
        toggleAdditionalInfo();

        $(document).on("click", function (e) {
          if (!$(e.target).closest('.surveys-list__top-right .item-list').length) {
            setTimeout(function () {
              $(".surveys-list__top-right .item-list").removeClass("active");
            }, 200);
          }

          if (!$(e.target).closest('.reviews-group__actions-wrapper .dropdown-menu').length) {
            $(".reviews-group__actions-wrapper .dropdown-menu").removeClass("active");
          }

          if (!$(e.target).closest('.surveys-list__additional-info__list').length) {
            $(".surveys-list__additional-info__list").removeClass("active");
          }

          if (!$(e.target).closest('.surveys-list__details-wrapper').length) {
            $(".surveys-list__details-wrapper").removeClass("active");
            $(".surveys-list__toggler").removeClass("active");
          }
        });

        $(".reviews-group__actions-wrapper .dropdown-menu a").on("click", function () {
          $(this).closest(".dropdown-menu").removeClass("active");
        });

        $(".surveys-list__top-right .item-list a").on("click", function () {
          const $itemList = $(this).closest(".item-list");

          setTimeout(function () {
            $itemList.removeClass("active");
          }, 200);
        });

        $(document).on("dialogclose", function () {
          attachEditDropdownHandlers();
          attachEditDropdownHandlers2();
          attachAdditionalInfoHandlers();
          toggleAdditionalInfo();
        });
      });
    },
  };

  Drupal.behaviors.selectAllCheckbox = {
    attach: function(context, settings) {
      jQuery(document).ready(function ($) {

        const selectAllCheckbox = $('body[class*="path-reviews-group-manager"] input[id*="edit-select-all"]');
        const autocompleteContainer = $('body[class*="path-reviews-group-manager"] .autocomplete-deluxe-container.autocomplete-deluxe-multiple');

        selectAllCheckbox.on('change', function () {
          if ($(this).is(':checked')) {
            autocompleteContainer.addClass('disabled');
          } else {
            autocompleteContainer.removeClass('disabled');
          }
        });
      });
    }
  }

  Drupal.behaviors.preventScrollOnExport = {
    attach: function (context, settings) {
      let scrollTopBeforeSubmit = 0;

      $('form.nn-surveys-export-ai-analysis', context).on('submit', function () {
        scrollTopBeforeSubmit = $(window).scrollTop();
      });

      $(document).on('dialogclose', function (event) {
        setTimeout(function () {
          window.scrollTo(0, scrollTopBeforeSubmit);
        }, 50);
      });
    }
  };

  Drupal.behaviors.graphsScale = {
    attach: function(context, settings) {
      jQuery(document).ready(function ($) {
        $('.skill-cards-dashboard-block .card-wrapper, .card-details__graph-chart').each(function () {
          if ($(this).find('.employee-card-graph-block.default').length > 0) {
            $(this).addClass('has-default');
          }

          if ($(this).find('.employee-card-graph-block').length < 2) {
            $(this).addClass('only-one');
          }
        });

        function filterSelectOptionsForGraphs() {
          // Show/hide graphs based on selection
          $('.card-wrapper, .card-details__graph-chart').each(function () {
            const $wrapper = $(this);

            // Skip everything if this has "only-one"
            if ($wrapper.hasClass('only-one')) return;

            const $graphBlocks = $wrapper.find('.employee-card-graph-block');
            const $defaultBlock = $graphBlocks.filter('.default');
            const $select = $wrapper.find('select.scale-select');

            $graphBlocks.not('.default').addClass('hidden');
            $defaultBlock.removeClass('hidden');

            // If there's NO .default, show the first graph block
            if ($defaultBlock.length === 0 && $graphBlocks.length > 0) {
              $graphBlocks.first().removeClass('hidden');
            }

            // Handle selection change
            $wrapper.find('select.scale-select').on('change', function () {
              const selectedValue = $(this).val();

              if ($wrapper.hasClass('only-one')) return;

              $graphBlocks.addClass('hidden');
              $graphBlocks.filter('.max-value-' + selectedValue).removeClass('hidden');
            });

            const allowedValues = $graphBlocks.map(function () {
              const match = $(this).attr('class').match(/max-value-(\d+)/);
              return match ? match[1] : null;
            }).get();

            // Filter native <option> elements
            $select.find('option').each(function () {
              const val = $(this).val();
              if (val === "" || allowedValues.includes(val)) {
                $(this).removeClass('hidden');
              } else {
                $(this).addClass('hidden');
              }
            });

            $select.data('allowed-values', allowedValues);

            $select.select2({
              matcher: function(params, data) {
                const allowedValues = $select.data('allowed-values');
                if (!data.id || $.trim(data.id) === '') return data;
                if (allowedValues.includes(data.id)) return data;
                return null;
              }
            });

            // Listen for dropdown opening and then hide unwanted options
            $select.on('select2:open', function () {
              const dropdownId = $(this).attr('aria-controls');
              const allowedValues = $(this).data('allowed-values');

              setTimeout(function () {
                const $dropdown = $('#' + dropdownId);

                $dropdown.find('.select2-results__option').each(function () {
                  const text = $(this).text().trim();
                  if (text === "Scale") return;

                  if (!allowedValues.includes(text)) {
                    $(this).addClass('hidden');
                  } else {
                    $(this).removeClass('hidden');
                  }
                });
              }, 10);
            });
          });
        }

        filterSelectOptionsForGraphs();

      });
    }
  }

  Drupal.behaviors.preventMultipleClicks = {
    attach: function (context, settings) {
      $('form.nn-feedback-feedback-create-form, form.nn-feedback-feedback-create-request-form, form.nn-comment-form-feedback-comment', context).each(function () {
        const $form = $(this);

        if ($form.hasClass('prevent-submit-handler-attached')) {
          return;
        }

        $form.addClass('prevent-submit-handler-attached');

        $form.on('submit', function (e) {
          const form = this;
          const $button = $(form).find('input.form-submit');

          setTimeout(function () {
            if (form.checkValidity()) {
              $button.prop('disabled', true);
            }
          }, 0);
        });
      });
    }
  };

  Drupal.behaviors.preventMultipleClicks2 = {
    attach: function (context, settings) {
      $('form.nn-comment-form-review-question-comment', context).each(function () {
        const $form = $(this);

        if ($form.hasClass('prevent-submit-handler-attached')) {
          return;
        }

        $form.addClass('prevent-submit-handler-attached');

        $form.on('submit', function (e) {
          const form = this;
          const $button = $(form).find('input.form-submit');

          setTimeout(function () {
            if (form.checkValidity()) {
              $button.prop('disabled', true);
            }
          }, 0);
        });
      });

      $('form', context).each(function () {
        const $form = $(this);

        if ($form.hasClass('prevent-submit-handler-attached')) {
          return;
        }
        $form.addClass('prevent-submit-handler-attached');

        $form.on('submit', function (e) {
          const form = this;

          const $buttons = $(form).find('input#edit-submit');

          setTimeout(function () {
            if (form.checkValidity()) {
              $buttons.prop('disabled', true).addClass('is-disabled');
            }
          }, 0);
        });
      });      
    }
  }

  Drupal.behaviors.formThrobber = {
    attach: function (context, settings) {
      // Only run this behavior on the specific page
      if ($('body').hasClass('path-app-employees-upload-csv') || $('body').hasClass('path-app-teams-upload-csv')) {

        $('form', context).on('form-throbber').each(function () {
          const $form = $(this);
          $form.find('input[id*="next-step"]').on('click', function (e) {
            // Show throbber only if not already present
            if (!$('#custom-throbber').length) {
              const throbber = $(`
              <div class="custom-throbber throbber-custom throbber-custom--ajax">
                <div class="ajax-progress ajax-progress-throbber webform-loader">
                  <div class="throbber">&nbsp;</div>
                  <div class="message">Please wait...</div>
                </div>
              </div>
            `);
              $('body').append(throbber);
            }
          });
        });
      }
    }
  };

  Drupal.behaviors.doubleClickFix = {
    attach: function (context, settings) {
      once('force-redirect', 'body.path-app .menu #edit-create:not(.use-ajax)', context).forEach(function (el) {
        el.addEventListener(
          'mousedown',
          function (e) {
            if (e.which !== 1) return;

            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            window.location.href = el.getAttribute('href');
          },
          true
        );
      });
    }
  };

  Drupal.behaviors.scrollAfterPaginationClick = {
    attach: function (context, settings) {

      $(document).on('click', '.admin-teams .pager__items a', function () {
        const href = $(this).attr('href');
        const pageParam = new URLSearchParams(href.split('?')[1]).get('page');
        const currentPageParam = new URLSearchParams(window.location.search).get('page') || '0,0';

        if (pageParam) {
          const newParts = pageParam.split(',').map(Number);
          const currentParts = currentPageParam.split(',').map(Number);

          if (newParts.length === 1) {
            // Only one pagination on the page (assume it's #team-members if exists)
            if ($('#team-members').length) {
              sessionStorage.setItem('scrollTarget', 'team-members');
            } else if ($('#evaluation-pairs').length) {
              sessionStorage.setItem('scrollTarget', 'evaluation-pairs');
            }
          } else if (newParts.length === 2) {
            const [newFirst, newSecond] = newParts;
            const [currFirst, currSecond] = currentParts;

            if (newFirst !== currFirst) {
              sessionStorage.setItem('scrollTarget', 'team-members');
            } else if (newSecond !== currSecond) {
              sessionStorage.setItem('scrollTarget', 'evaluation-pairs');
            }
          }
        }
      });

      $(document).ready(function () {
        const offset = 80;
        const scrollTargetId = sessionStorage.getItem('scrollTarget');

        if (scrollTargetId) {
          setTimeout(() => {
            const target = $('#' + scrollTargetId);
            if (target.length) {
              $('html, body').animate({
                scrollTop: target.offset().top - offset
              }, 400);
            }
            sessionStorage.removeItem('scrollTarget');
          }, 200);
        } else {
          // No sessionStorage → try to infer from URL
          const urlParams = new URLSearchParams(window.location.search);
          const pageParam = urlParams.get('page');

          if (pageParam) {
            const parts = pageParam.split(',').map(Number);
            let inferredTarget = null;

            if (parts.length === 1 && parts[0] > 0) {
              // One-part page param: assume only one pagination exists
              if ($('#team-members').length) {
                inferredTarget = 'team-members';
              } else if ($('#evaluation-pairs').length) {
                inferredTarget = 'evaluation-pairs';
              }
            } else if (parts.length === 2) {
              const [first, second] = parts;

              if (first > 0 && second === 0) {
                inferredTarget = 'team-members';
              } else if (second > 0 && first === 0) {
                inferredTarget = 'evaluation-pairs';
              } else if (first > 0 && second > 0) {
                inferredTarget = 'team-members'; // default (or change to evaluation-pairs if preferred)
              }
            }

            if (inferredTarget) {
              setTimeout(() => {
                const target = $('#' + inferredTarget);
                if (target.length) {
                  $('html, body').animate({
                    scrollTop: target.offset().top - offset
                  }, 400);
                }
              }, 200);
            }
          }
        }
      });
    }
  };

  Drupal.behaviors.convertLabelIntoPlaceholder = {
    attach: function (context, settings) {

      function initSelect2Placeholder($select) {
        if (!$select.length) return;

        if (!$select.attr('data-placeholder')) {
          const $label = $('label[for="' + $select.attr('id') + '"]');
          if ($label.length) {
            const labelText = Drupal.t($label.text().trim());
            $select.attr('data-placeholder', labelText);
            $label.remove();
          }
        }

        const placeholderText = $select.attr('data-placeholder') || Drupal.t('Select an option');

        if ($select.prop('multiple') && $select.find('option[value=""]').length === 0) {
          $select.prepend('<option value=""></option>');
        }

        if ($select.hasClass('select2-hidden-accessible')) {
          try { $select.select2('destroy'); } catch (e) {
            // safe to ignore
          }
        }

        $select.select2({
          placeholder: placeholderText,
          width: 'resolve',
          allowClear: true
        });
      }

      // function initSelect2ForContainer($container) {
      //   $container.find('.ed-review-automations-manage-review-automations .filters-container select').each(function () {
      //     initSelect2Placeholder($(this));
      //   });
      // }

      function initSelect2ForContainer($container) {
        $container.find('.ed-review-automations-manage-review-automations .filters-container select').each(function () {
          const $select = $(this);

          // Only run if select2 will render it as multiple
          if ($select.prop('multiple') || $select.hasClass('select2-selection--multiple')) {
            initSelect2Placeholder($select);
          }
        });
      }

      // Initial load
      initSelect2ForContainer($(context));

      // Re-init after any Drupal AJAX replacement
      $(document).ajaxComplete(function () {
        const $wrapper = $('.ed-review-automations-manage-review-automations #filters-wrapper, .edit-survey-add-element-form #filters-wrapper');
        if ($wrapper.length) {
          initSelect2ForContainer($wrapper);
        }
      });

      // Hide label for single selects
      $('.ed-review-automations-manage-review-automations #filters-wrapper .form-type-select').each(function () {
        const $parent = $(this);
        if ($parent.find('.select2-selection--single').length > 0) {
          $parent.addClass('single-select');
        }
      });

      $('.age-range-wrapper:not(.filter-range-initialized), .tenure-range-wrapper:not(.filter-range-initialized)', context).each(function () {
        const $wrapper = $(this);
        $wrapper.addClass('filter-range-initialized');

        $wrapper.on('click', function (e) {
          const isSpanClicked = $(e.target).is('span');
          if (isSpanClicked) {
            $('.age-range-wrapper, .tenure-range-wrapper').not($wrapper).removeClass('show');
            $wrapper.toggleClass('show');
          }
          else if (e.target === e.currentTarget) {
            $wrapper.removeClass('show');
          }
          e.stopPropagation();
        });
      });

      $(document).off('click.filterRangeSlider').on('click.filterRangeSlider', function (e) {
        if (!$(e.target).closest('.age-range-wrapper, .tenure-range-wrapper').length) {
          $('.age-range-wrapper, .tenure-range-wrapper').removeClass('show');
        }
      });

      function initRangeDisplay(wrapperSelector, sliderSelector, minInputName, maxInputName, defaultMin, defaultMax) {
        const $wrapper = $(wrapperSelector, context);
        const $applyBtn = $wrapper.find('.apply-reset-wrapper .button.primary');
        const $resetBtn = $wrapper.find('.apply-reset-wrapper .button.secondary');
        const $label = $wrapper.find('> span');
        const $slider = $(sliderSelector, context);

        // Use hidden input values if present; fallback to defaults
        const currentMin = $(`input[name="${minInputName}"]`).val() || defaultMin;
        const currentMax = $(`input[name="${maxInputName}"]`).val() || defaultMax;

        function updateDisplay(min, max) {
          let $display = $label.find('.range-display');
          if (!$display.length) {
            $display = $('<span class="range-display"></span>');
            $label.append($display);
          }
          $display.text(`: ${min} - ${max}`);
        }

        // Initialize display on page load
        updateDisplay(currentMin, currentMax);

        // Apply / Submit button updates display with current hidden input values
        $applyBtn.off(`click.apply${wrapperSelector}`).on(`click.apply${wrapperSelector}`, function () {
          const min = $(`input[name="${minInputName}"]`).val();
          const max = $(`input[name="${maxInputName}"]`).val();
          updateDisplay(min, max);
        });

        // Reset button restores slider and hidden inputs to hardcoded defaults
        $resetBtn.off(`click.reset${wrapperSelector}`).on(`click.reset${wrapperSelector}`, function () {
          $(`input[name="${minInputName}"]`).val(defaultMin);
          $(`input[name="${maxInputName}"]`).val(defaultMax);

          // Reset slider visually
          if ($slider[0] && $slider[0].noUiSlider) {
            $slider[0].noUiSlider.set([defaultMin, defaultMax]);
          }

          // Update display to defaults
          updateDisplay(defaultMin, defaultMax);
        });
      }

      // Age: hardcoded 0 - 100
      initRangeDisplay('.age-range-wrapper', '#age-range-slider', 'filters[age_range][min_age]', 'filters[age_range][max_age]', 0, 100);

      // Tenure: hardcoded 0 - 50
      initRangeDisplay('.tenure-range-wrapper', '#tenure-range-slider', 'filters[tenure_range][min_tenure]', 'filters[tenure_range][max_tenure]', 0, 50);

      // Check if Age/Tenure is edited
      function updateEdited($wrapper, minSelector, maxSelector, defaultMin, defaultMax) {
        const min = parseInt($wrapper.closest('[id$="-range-wrapper"]').find(minSelector).val(), 10);
        const max = parseInt($wrapper.closest('[id$="-range-wrapper"]').find(maxSelector).val(), 10);

        if (!(min === defaultMin && max === defaultMax)) {
          $wrapper.addClass('edited');
        } else {
          $wrapper.removeClass('edited');
        }
      }

      function checkAll() {
        // Age
        $('.age-range-wrapper', context).each(function () {
          updateEdited($(this),
            'input[name="filters[age_range][min_age]"]',
            'input[name="filters[age_range][max_age]"]',
            0, 100
          );
        });

        // Tenure
        $('.tenure-range-wrapper', context).each(function () {
          updateEdited($(this),
            'input[name="filters[tenure_range][min_tenure]"]',
            'input[name="filters[tenure_range][max_tenure]"]',
            0, 50
          );
        });
      }

      checkAll();

      $('.apply-reset-wrapper .button.primary').on('click', function (e) {
        checkAll();
      });

      $('.apply-reset-wrapper .button.secondary').on('click', function (e) {
        $('.age-range-wrapper, .tenure-range-wrapper').removeClass('edited');
      });
    }
  }

  Drupal.behaviors.toggleFilters = {
    attach: function (context, settings) {
      const $container = $('.ed-review-automations-manage-review-automations .filters-container, .edit-survey-add-element-form .filters-container, form[class*="-html-block-form"] .filters-container', context);

      $container.each(function () {
        const $this = $(this);
        if ($this.data('filters-toggle-attached')) return;
        $this.data('filters-toggle-attached', true);

        const $children = $this.children('div');
        const $button = $this.find('.more-filters-button');

        if ($children.length > 5) {
          $children.slice(0, 5).slideDown();
          $children.slice(5).hide();
          $button.text(Drupal.t('More filters')).show();

          $button.on('click', function (e) {
            e.preventDefault();
            const hidden = $children.slice(5).is(':hidden');

            if (hidden) {
              $children.slice(5).slideDown();
              $button.text(Drupal.t('Fewer filters'));
            } else {
              $children.slice(5).slideUp();
              $button.text(Drupal.t('More filters'));
            }
          });
        } else {
          $button.hide();
        }
      });
    }
  };

  Drupal.behaviors.checkEvaluatorCheckbox = {
    attach: function (context, settings) {
      jQuery(document).ready(function($) {
        const $evaluatorCheckbox = $('.admin-team-edit-member-form .form-item-group-roles-team-evaluator > input');
        const $evaluatorWarning = $('.admin-team-edit-member-form .evaluator-warning');
        const $confirmationCheckbox = $('.admin-team-edit-member-form .form-item-evaluator-notice > input');
        const $updateButton = $('.admin-team-edit-member-form input.form-submit');

        const toggleWarningAndButton = () => {
          // If evaluator-warning doesn't exist, enable button and exit
          if ($evaluatorWarning.length === 0) {
            $updateButton.removeClass('not-clickable').prop('disabled', false);
            return;
          }

          if (!$evaluatorCheckbox.is(':checked')) {
            // Show warning
            $evaluatorWarning.addClass('visible');

            // If confirmation not checked, disable update button
            if (!$confirmationCheckbox.is(':checked')) {
              $updateButton.addClass('not-clickable').prop('disabled', true);
            }
          } else {
            // Hide warning and enable update button
            $evaluatorWarning.removeClass('visible');
            $updateButton.removeClass('not-clickable').prop('disabled', false);
          }
        };

        // Run on page load in case evaluator is unchecked
        toggleWarningAndButton();

        // When Evaluator checkbox changes
        $evaluatorCheckbox.change(() => {
          toggleWarningAndButton();
        });

        // When confirmation checkbox changes
        $confirmationCheckbox.change(() => {
          if ($evaluatorCheckbox.is(':checked')) {
            // Do nothing if evaluator is still checked
            $updateButton.removeClass('not-clickable').prop('disabled', false);
          } else {
            if ($confirmationCheckbox.is(':checked')) {
              $updateButton.removeClass('not-clickable').prop('disabled', false);
            } else {
              $updateButton.addClass('not-clickable').prop('disabled', true);
            }
          }
        });
      });
    }
  };

  Drupal.behaviors.checkAioModal = {
    attach: function (context, settings) {
      $(document).on('dialogopen', function (event) {
        const $dialog = $(event.target).closest('.ui-dialog');
        if ($dialog.find('.aio-modal-block').length) {
          $dialog.addClass('aio-modal');
        }
      });
    }
  };

  Drupal.behaviors.checkIfParagraphExists = {
    attach: function (context, settings) {
      const selector = '.question-wrapper-container.required-question .question__title-wrapper .form-element-label';

      const apply = ($scope) => {
        $scope.find(selector).each(function () {
          const $label = $(this);
          if ($label.find('p').length) {
            $label.addClass('has-paragraph');
          }
        });
      };

      const $ctx = $(context);
      apply($ctx);
      setTimeout(() => apply($ctx), 0);
    }
  };

  Drupal.behaviors.mobileUserMenu = {
    attach: function(context, settings) {
      const mobileBreakpoint = 600;
      const element = once('mobileUserMenuToggle', '.icons-right .mobile-menu-wrapper > a[href^="/profile"]', context);
      const $profileLink = $(element);

      if (!$profileLink.length) {
        return;
      }

      const $iconsRight = $profileLink.closest('.icons-right');
      const $mobileMenuWrapper = $profileLink.closest('.mobile-menu-wrapper');
      const $mobileMenuBlock = $mobileMenuWrapper.children('.mobile-menu-block');
      const $mobileMenuActions = $mobileMenuBlock.find('.mobile-menu-block__actions');
      const $insightsIcon = $iconsRight.children('.insights-icon');
      const $languageWrapper = $iconsRight.children('.language-dropdown-wrapper');
      const $themeModeForm = $iconsRight.children('.theme-mode-form');

      function setMobileMenuOpen(isOpen) {
        $mobileMenuBlock.toggleClass('hidden', !isOpen);
        $profileLink.toggleClass('opened', isOpen);
      }

      function relocateMobileMenuItems() {
        if (window.innerWidth < mobileBreakpoint) {
          $mobileMenuActions.append($languageWrapper, $themeModeForm, $insightsIcon);
        } else {
          $insightsIcon.insertBefore($mobileMenuWrapper);
          $languageWrapper.insertBefore($mobileMenuWrapper);
          $themeModeForm.insertBefore($mobileMenuWrapper);
          setMobileMenuOpen(false);
        }
      }

      relocateMobileMenuItems();
      $(window).on('resize.mobileUserMenu', relocateMobileMenuItems);

      $profileLink.on('click', function(e) {
        if (window.innerWidth < mobileBreakpoint) {
          e.preventDefault();
          setMobileMenuOpen($mobileMenuBlock.hasClass('hidden'));
        }
      });

      // close mobile user menu when clicking outside of it, or on a link inside the dropdown
      const body = once('mobileUserMenuClickOutside', 'body', context);
      $(body).on('click', function(e) {
        if (window.innerWidth >= mobileBreakpoint || $mobileMenuBlock.hasClass('hidden')) {
          return;
        }

        const $target = $(e.target);
        const $link = $target.closest('a');
        const clickedOutside = !$target.closest($mobileMenuWrapper).length;
        const clickedDropdownLink = $link.length && $mobileMenuBlock.has($link).length;

        if (clickedOutside || clickedDropdownLink) {
          setMobileMenuOpen(false);
        }
      });
    }
  }

  Drupal.behaviors.mobileInsightsIconLink = {
    attach: function(context, settings) {
      const mobileBreakpoint = 600;
      const element = once('mobileInsightsIconLink', '.icons-right .insights-icon', context);
      const $insightsIcon = $(element);
      const $link = $insightsIcon.find('a[href*="/insights/kpis"]');

      if (!$link.length) {
        return;
      }

      $insightsIcon.on('click', function(e) {
        if (window.innerWidth < mobileBreakpoint && !$(e.target).closest('a').length) {
          $link[0].click();
        }
      });
    }
  }
  Drupal.behaviors.wrapOkrSearchFilter = {
    attach: function (context, settings) {
      const elements = once('wrapOkrSearchFilter', '.path-okr #edit-filter-wrapper, .path-okr-tree #edit-filter-wrapper', context);

      elements.forEach((element) => {
        const $this = $(element);

        const $search = $this.children('label.form-element-label').first()
          .add($this.children('.autocomplete-deluxe-container'))
          .add($this.children('.autocomplete-deluxe-value-container'));

        if ($search.length) {
          $search.wrapAll('<div class="filter-search-wrapper"></div>');
          $this.find('.filter-search-wrapper').prependTo($this);
        }

        const $buttons = $this.children('input[type="submit"]').slice(-2);

        if ($buttons.length) {
          $buttons.wrapAll('<div class="buttons-wrapper"></div>');
          $this.find('.buttons-wrapper').appendTo($this);
        }
      });
    }
  };

  Drupal.behaviors.wrapOkrTeamHeading = {
    attach: function (context, settings) {
      const elements = once('wrapOkrTeamHeading', '.path-okr .team-details .team-click, .path-okr-tree .team-details .team-click', context);

      elements.forEach((element) => {
        const $this = $(element);

        const $heading = $this.children('h3')
          .add($this.children('.orphaned-goals-count'));

        if ($heading.length) {
          $heading.wrapAll('<div class="team-heading-wrapper"></div>');
          $this.find('.team-heading-wrapper').prependTo($this);
        }
      });
    }
  };

  Drupal.behaviors.wrapOkrTeams = {
    attach: function (context, settings) {
      const elements = once('wrapOkrTeams', '.path-okr #edit-filters', context);

      elements.forEach((element) => {
        const $filters = $(element);
        const $teams = $filters.nextAll('.team');

        if ($teams.length) {
          $teams.wrapAll('<div class="teams-wrapper"></div>');
          $filters.after($filters.siblings('.teams-wrapper'));
        }
      });
    }
  };

  Drupal.behaviors.okrTreeCollapsible = {
    attach: function (context, settings) {
      const toggles = once('okrTreeCollapsible', '.okr-tree-toggle-placeholder', context);

      toggles.forEach((toggle) => {
        const $toggle = $(toggle);
        const $row = $toggle.closest('.okr-tree-row');
        // The children list lives in the node's wrapper, as a sibling of
        // the node itself — so grab it relative to this row's node.
        const $children = $toggle.closest('.okr-tree-node').parent().children('.okr-tree-children');

        // Leaf node: no child items, so nothing to toggle.
        if (!$children.find('.okr-tree-item').length) {
          $toggle.addClass('okr-tree-toggle-placeholder--empty');
          return;
        }

        // Start collapsed: hide this row's direct children level.
        $row.addClass('is-collapsed');
        $children.hide();

        $toggle.on('click', function () {
          if ($row.hasClass('is-collapsed')) {
            $children.show();
            $row.removeClass('is-collapsed').addClass('is-expanded');
          } else {
            $children.hide();
            $row.removeClass('is-expanded').addClass('is-collapsed');
          }
        });
      });
    }
  };

  Drupal.behaviors.okrTreeActiveRow = {
    attach: function (context, settings) {
      const lists = once('okrTreeActiveRow', '.okr-tree-list', context);

      lists.forEach((list) => {
        list.addEventListener('mousedown', function (event) {
          if (event.button !== 0) {
            return;
          }

          const row = event.target.closest('.okr-tree-row');

          if (!row || !list.contains(row)) {
            return;
          }

          if (event.target.closest('.okr-tree-toggle-placeholder')) {
            return;
          }

          $('.okr-tree-row.is-active', list).removeClass('is-active');
          $(row).addClass('is-active');

          const select = row.querySelector('.okr-tree-select');

          if (select && event.target !== select) {
            select.dispatchEvent(new MouseEvent('mousedown', {
              bubbles: true,
              cancelable: true,
              view: window,
            }));
          }
        }, true);
      });
    }
  };

  Drupal.behaviors.okrTreeExpandActive = {
    attach: function (context, settings) {
      const lists = once('okrTreeExpandActive', '.okr-tree-list', context);

      lists.forEach((list) => {
        const $activeRow = $('.okr-tree-row.is-active', list);

        if (!$activeRow.length) {
          return;
        }

        $activeRow.parents('.okr-tree-children').each(function () {
          const $children = $(this);
          const $parentRow = $children
            .parent()
            .children('.okr-tree-node')
            .children('.okr-tree-row');

          $children.show();
          $parentRow.removeClass('is-collapsed').addClass('is-expanded');
        });
      });
    }
  };

  Drupal.behaviors.okrTransferInfiniteScroll = {
    attach: function (context, settings) {
      const wrappers = once('okrTransferInfiniteScroll', '#edit-objectives-wrapper', context);

      wrappers.forEach((wrapper) => {
        const $wrapper = $(wrapper);
        const $table = $wrapper.find('#edit-objectives');
        const $tbody = $table.find('tbody');
        const $pager = $wrapper.find('.pager');

        if (!$table.length || !$tbody.length || !$pager.length) {
          return;
        }

        const lastHref = $pager.find('.pager__item--last a').attr('href')
          || $pager.find('.pager__item a').last().attr('href');
        const readPage = (href) => {
          const value = new URLSearchParams((href || '').split('?')[1]).get('page');
          return value === null ? 0 : parseInt(value, 10);
        };

        let currentPage = readPage(window.location.search) || 0;
        const lastPage = lastHref ? readPage(lastHref) : currentPage;

        $pager.remove();

        if (currentPage >= lastPage) {
          return;
        }

        const $sentinel = $('<div class="okr-transfer__scroll-sentinel"></div>');
        $wrapper.append($sentinel);

        let isLoading = false;

        const loadNextPage = () => {
          if (isLoading || currentPage >= lastPage) {
            return;
          }

          isLoading = true;
          $wrapper.addClass('is-loading');

          const url = new URL(window.location.href);
          url.searchParams.set('page', currentPage + 1);

          fetch(url.toString(), {
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            credentials: 'same-origin',
          })
            .then((response) => response.text())
            .then((html) => {
              const doc = new DOMParser().parseFromString(html, 'text/html');
              const rows = doc.querySelectorAll('#edit-objectives tbody tr');

              if (rows.length) {
                $tbody.append($(rows));
                Drupal.attachBehaviors($tbody.get(0), settings);
                currentPage += 1;
              } else {
                currentPage = lastPage;
              }
            })
            .catch(() => {
              // Leave things as-is so the user can scroll to retry.
            })
            .then(() => {
              isLoading = false;
              $wrapper.removeClass('is-loading');

              if (currentPage >= lastPage) {
                observer.disconnect();
                $sentinel.remove();
              }
            });
        };

        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              loadNextPage();
            }
          });
        }, { rootMargin: '200px' });

        observer.observe($sentinel.get(0));
      });
    }
  };

  Drupal.behaviors.okrTransferBulkActionsToggle = {
    attach: function (context, settings) {
      const forms = once('okrTransferBulkActionsToggle', 'form.ed-okr-transfer-manager', context);

      forms.forEach((form) => {
        const $form = $(form);
        const $bulkActions = $form.find('.okr-transfer__bulk-actions');
        const $table = $form.find('table.okr-transfer__table');

        if (!$bulkActions.length || !$table.length) {
          return;
        }

        const toggleBulkActions = () => {
          const hasSelection = $table.find('.okr-transfer__table.form-checkbox:checked').length > 0;
          $bulkActions.toggleClass('is-hidden', !hasSelection);
        };

        $table.on('change', 'input[type="checkbox"]', toggleBulkActions);

        toggleBulkActions();
      });
    }
  };

})(jQuery, window, document, Drupal, flatpickr, autosize);

export default custom;
